/* tslint:disable */
/* eslint-disable */
/**
 * V1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import globalAxios from 'axios';
// Some imports not used depending on template conditions
import { DUMMY_BASE_URL, assertParamExists, setBearerAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import { BASE_PATH, BaseAPI } from './base';
/**
 *
 * @export
 * @enum {string}
 */
export var B2BShippingType;
(function (B2BShippingType) {
    B2BShippingType["SeabourneStandard"] = "seabourneStandard";
    B2BShippingType["SeabournePallet"] = "seabournePallet";
    B2BShippingType["DhlExpress"] = "dhlExpress";
    B2BShippingType["Pickup"] = "pickup";
})(B2BShippingType || (B2BShippingType = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var BottomType;
(function (BottomType) {
    BottomType["Empty"] = "empty";
    BottomType["MatchPlate"] = "matchPlate";
    BottomType["MatchPlateTwoPhotos"] = "matchPlateTwoPhotos";
    BottomType["TwoPhotos"] = "twoPhotos";
    BottomType["ThreePhotos"] = "threePhotos";
})(BottomType || (BottomType = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var ClubLogoType;
(function (ClubLogoType) {
    ClubLogoType["MatchPlateInscription"] = "matchPlateInscription";
    ClubLogoType["FrameTop"] = "frameTop";
})(ClubLogoType || (ClubLogoType = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var ConfigurationMode;
(function (ConfigurationMode) {
    ConfigurationMode["B2C"] = "b2C";
    ConfigurationMode["B2B"] = "b2B";
    ConfigurationMode["ConfigurationTemplate"] = "configurationTemplate";
})(ConfigurationMode || (ConfigurationMode = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var ConfigurationStatus;
(function (ConfigurationStatus) {
    ConfigurationStatus["PendingConfiguration"] = "pendingConfiguration";
    ConfigurationStatus["PendingConfirmation"] = "pendingConfirmation";
    ConfigurationStatus["Confirmed"] = "confirmed";
    ConfigurationStatus["Rejected"] = "rejected";
})(ConfigurationStatus || (ConfigurationStatus = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var FeatureType;
(function (FeatureType) {
    FeatureType["Frame"] = "frame";
    FeatureType["Glass"] = "glass";
    FeatureType["Lighting"] = "lighting";
    FeatureType["Matchplate"] = "matchplate";
    FeatureType["MatchplateExtras"] = "matchplateExtras";
    FeatureType["PassePartout"] = "passePartout";
    FeatureType["Shipping"] = "shipping";
    FeatureType["Fold"] = "fold";
    FeatureType["Sleeves"] = "sleeves";
    FeatureType["ClubLogo"] = "clubLogo";
    FeatureType["Photos"] = "photos";
})(FeatureType || (FeatureType = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var FoldOption;
(function (FoldOption) {
    FoldOption["Back"] = "back";
    FoldOption["Front"] = "front";
})(FoldOption || (FoldOption = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var FoldingType;
(function (FoldingType) {
    FoldingType["BackAndFront"] = "backAndFront";
    FoldingType["Back"] = "back";
    FoldingType["Front"] = "front";
})(FoldingType || (FoldingType = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var FrameColor;
(function (FrameColor) {
    FrameColor["Aluminium"] = "aluminium";
    FrameColor["Black"] = "black";
})(FrameColor || (FrameColor = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var GlassType;
(function (GlassType) {
    GlassType["Regular"] = "regular";
    GlassType["MuseumGrade"] = "museumGrade";
})(GlassType || (GlassType = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var MatchPlateBrandingOption;
(function (MatchPlateBrandingOption) {
    MatchPlateBrandingOption["Branding"] = "branding";
    MatchPlateBrandingOption["NoBranding"] = "noBranding";
})(MatchPlateBrandingOption || (MatchPlateBrandingOption = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var MatchPlateClubLogoOption;
(function (MatchPlateClubLogoOption) {
    MatchPlateClubLogoOption["None"] = "none";
    MatchPlateClubLogoOption["ClubLogo"] = "clubLogo";
})(MatchPlateClubLogoOption || (MatchPlateClubLogoOption = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var MatchPlateColor;
(function (MatchPlateColor) {
    MatchPlateColor["Aluminium"] = "aluminium";
    MatchPlateColor["Brass"] = "brass";
})(MatchPlateColor || (MatchPlateColor = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var MatchPlateImageType;
(function (MatchPlateImageType) {
    MatchPlateImageType["Branding"] = "branding";
    MatchPlateImageType["Logo"] = "logo";
})(MatchPlateImageType || (MatchPlateImageType = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var MatchPlateOption;
(function (MatchPlateOption) {
    MatchPlateOption["ClubLogo"] = "clubLogo";
    MatchPlateOption["NoBranding"] = "noBranding";
})(MatchPlateOption || (MatchPlateOption = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var MatchPlateType;
(function (MatchPlateType) {
    MatchPlateType["None"] = "none";
    MatchPlateType["Silver"] = "silver";
    MatchPlateType["Gold"] = "gold";
})(MatchPlateType || (MatchPlateType = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var NewMatchPlateColor;
(function (NewMatchPlateColor) {
    NewMatchPlateColor["Silver"] = "silver";
    NewMatchPlateColor["Gold"] = "gold";
})(NewMatchPlateColor || (NewMatchPlateColor = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var OrderStatus;
(function (OrderStatus) {
    OrderStatus["AwaitingProduction"] = "awaitingProduction";
    OrderStatus["InProduction"] = "inProduction";
    OrderStatus["Shipped"] = "shipped";
    OrderStatus["Delivered"] = "delivered";
    OrderStatus["Closed"] = "closed";
    OrderStatus["AwaitingShirt"] = "awaitingShirt";
})(OrderStatus || (OrderStatus = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var PassePartoutType;
(function (PassePartoutType) {
    PassePartoutType["White"] = "white";
    PassePartoutType["Black"] = "black";
    PassePartoutType["Custom"] = "custom";
})(PassePartoutType || (PassePartoutType = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var PhotosType;
(function (PhotosType) {
    PhotosType["None"] = "none";
    PhotosType["TwoPhotos"] = "twoPhotos";
    PhotosType["ThreePhotos"] = "threePhotos";
})(PhotosType || (PhotosType = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var PresetStatus;
(function (PresetStatus) {
    PresetStatus["Published"] = "published";
    PresetStatus["Unpublished"] = "unpublished";
})(PresetStatus || (PresetStatus = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var SalesChannel;
(function (SalesChannel) {
    SalesChannel["Upsell"] = "upsell";
    SalesChannel["FrameInAuction"] = "frameInAuction";
    SalesChannel["D2C"] = "d2C";
    SalesChannel["B2B"] = "b2B";
    SalesChannel["AuctionItems"] = "auctionItems";
})(SalesChannel || (SalesChannel = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var SleevesOption;
(function (SleevesOption) {
    SleevesOption["NoSleeves"] = "noSleeves";
    SleevesOption["SleevesVisible"] = "sleevesVisible";
})(SleevesOption || (SleevesOption = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var SortDirection;
(function (SortDirection) {
    SortDirection["Ascending"] = "ascending";
    SortDirection["Descending"] = "descending";
})(SortDirection || (SortDirection = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var TopType;
(function (TopType) {
    TopType["Empty"] = "empty";
    TopType["ClubLogo"] = "clubLogo";
})(TopType || (TopType = {}));
/**
 * AdminConfigurationApi - axios parameter creator
 * @export
 */
export const AdminConfigurationApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Set custom matchPlate PDF on a configuration
         * @param {string} configurationId
         * @param {string} [temporaryUploadedUrl]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminConfigurationsConfigurationIdCustomMatchplatePdfPatch: (configurationId, temporaryUploadedUrl, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'configurationId' is not null or undefined
            assertParamExists('adminConfigurationsConfigurationIdCustomMatchplatePdfPatch', 'configurationId', configurationId);
            const localVarPath = `/admin/configurations/{configurationId}/custom-matchplate-pdf`
                .replace(`{${"configurationId"}}`, encodeURIComponent(String(configurationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            if (temporaryUploadedUrl !== undefined) {
                localVarQueryParameter['temporaryUploadedUrl'] = temporaryUploadedUrl;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * a 404 from this endpoint can be considered a valid response. Not all Configurations have a Frame Configuration  We tried to do a 204 for when there is no Frame Configuration, but it did not generate correctly in the SDK
         * @param {string} configurationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminConfigurationsConfigurationIdFrameConfigurationGet: (configurationId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'configurationId' is not null or undefined
            assertParamExists('adminConfigurationsConfigurationIdFrameConfigurationGet', 'configurationId', configurationId);
            const localVarPath = `/admin/configurations/{configurationId}/frame-configuration`
                .replace(`{${"configurationId"}}`, encodeURIComponent(String(configurationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} configurationId
         * @param {AdminConfigurationsConfigurationIdFrameConfigurationPatchRequest} [adminConfigurationsConfigurationIdFrameConfigurationPatchRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminConfigurationsConfigurationIdFrameConfigurationPatch: (configurationId, adminConfigurationsConfigurationIdFrameConfigurationPatchRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'configurationId' is not null or undefined
            assertParamExists('adminConfigurationsConfigurationIdFrameConfigurationPatch', 'configurationId', configurationId);
            const localVarPath = `/admin/configurations/{configurationId}/frame-configuration`
                .replace(`{${"configurationId"}}`, encodeURIComponent(String(configurationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(adminConfigurationsConfigurationIdFrameConfigurationPatchRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [Admin] Updates the notes of a configuration
         * @param {string} configurationId
         * @param {AdminConfigurationsConfigurationIdNotesPatchRequest} [adminConfigurationsConfigurationIdNotesPatchRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminConfigurationsConfigurationIdNotesPatch: (configurationId, adminConfigurationsConfigurationIdNotesPatchRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'configurationId' is not null or undefined
            assertParamExists('adminConfigurationsConfigurationIdNotesPatch', 'configurationId', configurationId);
            const localVarPath = `/admin/configurations/{configurationId}/notes`
                .replace(`{${"configurationId"}}`, encodeURIComponent(String(configurationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(adminConfigurationsConfigurationIdNotesPatchRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [Admin] Get configuration by ID
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminConfigurationsIdGet: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminConfigurationsIdGet', 'id', id);
            const localVarPath = `/admin/configurations/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Update print settings on a configuration by id.
         * @param {string} id
         * @param {AdminConfigurationsIdPrintSettingsPatchRequest} [adminConfigurationsIdPrintSettingsPatchRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminConfigurationsIdPrintSettingsPatch: (id, adminConfigurationsIdPrintSettingsPatchRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminConfigurationsIdPrintSettingsPatch', 'id', id);
            const localVarPath = `/admin/configurations/{id}/print-settings`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(adminConfigurationsIdPrintSettingsPatchRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Update shipping type on a configuration by id.
         * @param {string} id
         * @param {B2BShippingType} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminConfigurationsIdShippingTypePatch: (id, body, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminConfigurationsIdShippingTypePatch', 'id', id);
            const localVarPath = `/admin/configurations/{id}/shippingType`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get all configurations by partner id.
         * @param {string} partnerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminConfigurationsPartnerPartnerIdGet: (partnerId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'partnerId' is not null or undefined
            assertParamExists('adminConfigurationsPartnerPartnerIdGet', 'partnerId', partnerId);
            const localVarPath = `/admin/configurations/partner/{partnerId}`
                .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [FramingAdmin] Gets a configuration name, of a frameable product by productId
         * @param {string} productId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminConfigurationsProductIdConfigurationNameGet: (productId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('adminConfigurationsProductIdConfigurationNameGet', 'productId', productId);
            const localVarPath = `/admin/configurations/{productId}/configuration-name`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * AdminConfigurationApi - functional programming interface
 * @export
 */
export const AdminConfigurationApiFp = function (configuration) {
    const localVarAxiosParamCreator = AdminConfigurationApiAxiosParamCreator(configuration);
    return {
        /**
         * Set custom matchPlate PDF on a configuration
         * @param {string} configurationId
         * @param {string} [temporaryUploadedUrl]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminConfigurationsConfigurationIdCustomMatchplatePdfPatch(configurationId, temporaryUploadedUrl, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminConfigurationsConfigurationIdCustomMatchplatePdfPatch(configurationId, temporaryUploadedUrl, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * a 404 from this endpoint can be considered a valid response. Not all Configurations have a Frame Configuration  We tried to do a 204 for when there is no Frame Configuration, but it did not generate correctly in the SDK
         * @param {string} configurationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminConfigurationsConfigurationIdFrameConfigurationGet(configurationId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminConfigurationsConfigurationIdFrameConfigurationGet(configurationId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} configurationId
         * @param {AdminConfigurationsConfigurationIdFrameConfigurationPatchRequest} [adminConfigurationsConfigurationIdFrameConfigurationPatchRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminConfigurationsConfigurationIdFrameConfigurationPatch(configurationId, adminConfigurationsConfigurationIdFrameConfigurationPatchRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminConfigurationsConfigurationIdFrameConfigurationPatch(configurationId, adminConfigurationsConfigurationIdFrameConfigurationPatchRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [Admin] Updates the notes of a configuration
         * @param {string} configurationId
         * @param {AdminConfigurationsConfigurationIdNotesPatchRequest} [adminConfigurationsConfigurationIdNotesPatchRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminConfigurationsConfigurationIdNotesPatch(configurationId, adminConfigurationsConfigurationIdNotesPatchRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminConfigurationsConfigurationIdNotesPatch(configurationId, adminConfigurationsConfigurationIdNotesPatchRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [Admin] Get configuration by ID
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminConfigurationsIdGet(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminConfigurationsIdGet(id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Update print settings on a configuration by id.
         * @param {string} id
         * @param {AdminConfigurationsIdPrintSettingsPatchRequest} [adminConfigurationsIdPrintSettingsPatchRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminConfigurationsIdPrintSettingsPatch(id, adminConfigurationsIdPrintSettingsPatchRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminConfigurationsIdPrintSettingsPatch(id, adminConfigurationsIdPrintSettingsPatchRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Update shipping type on a configuration by id.
         * @param {string} id
         * @param {B2BShippingType} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminConfigurationsIdShippingTypePatch(id, body, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminConfigurationsIdShippingTypePatch(id, body, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get all configurations by partner id.
         * @param {string} partnerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminConfigurationsPartnerPartnerIdGet(partnerId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminConfigurationsPartnerPartnerIdGet(partnerId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [FramingAdmin] Gets a configuration name, of a frameable product by productId
         * @param {string} productId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminConfigurationsProductIdConfigurationNameGet(productId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminConfigurationsProductIdConfigurationNameGet(productId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * AdminConfigurationApi - factory interface
 * @export
 */
export const AdminConfigurationApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AdminConfigurationApiFp(configuration);
    return {
        /**
         * Set custom matchPlate PDF on a configuration
         * @param {AdminConfigurationApiAdminConfigurationsConfigurationIdCustomMatchplatePdfPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminConfigurationsConfigurationIdCustomMatchplatePdfPatch(requestParameters, options) {
            return localVarFp.adminConfigurationsConfigurationIdCustomMatchplatePdfPatch(requestParameters.configurationId, requestParameters.temporaryUploadedUrl, options).then((request) => request(axios, basePath));
        },
        /**
         * a 404 from this endpoint can be considered a valid response. Not all Configurations have a Frame Configuration  We tried to do a 204 for when there is no Frame Configuration, but it did not generate correctly in the SDK
         * @param {AdminConfigurationApiAdminConfigurationsConfigurationIdFrameConfigurationGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminConfigurationsConfigurationIdFrameConfigurationGet(requestParameters, options) {
            return localVarFp.adminConfigurationsConfigurationIdFrameConfigurationGet(requestParameters.configurationId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {AdminConfigurationApiAdminConfigurationsConfigurationIdFrameConfigurationPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminConfigurationsConfigurationIdFrameConfigurationPatch(requestParameters, options) {
            return localVarFp.adminConfigurationsConfigurationIdFrameConfigurationPatch(requestParameters.configurationId, requestParameters.adminConfigurationsConfigurationIdFrameConfigurationPatchRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [Admin] Updates the notes of a configuration
         * @param {AdminConfigurationApiAdminConfigurationsConfigurationIdNotesPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminConfigurationsConfigurationIdNotesPatch(requestParameters, options) {
            return localVarFp.adminConfigurationsConfigurationIdNotesPatch(requestParameters.configurationId, requestParameters.adminConfigurationsConfigurationIdNotesPatchRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [Admin] Get configuration by ID
         * @param {AdminConfigurationApiAdminConfigurationsIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminConfigurationsIdGet(requestParameters, options) {
            return localVarFp.adminConfigurationsIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update print settings on a configuration by id.
         * @param {AdminConfigurationApiAdminConfigurationsIdPrintSettingsPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminConfigurationsIdPrintSettingsPatch(requestParameters, options) {
            return localVarFp.adminConfigurationsIdPrintSettingsPatch(requestParameters.id, requestParameters.adminConfigurationsIdPrintSettingsPatchRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update shipping type on a configuration by id.
         * @param {AdminConfigurationApiAdminConfigurationsIdShippingTypePatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminConfigurationsIdShippingTypePatch(requestParameters, options) {
            return localVarFp.adminConfigurationsIdShippingTypePatch(requestParameters.id, requestParameters.body, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all configurations by partner id.
         * @param {AdminConfigurationApiAdminConfigurationsPartnerPartnerIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminConfigurationsPartnerPartnerIdGet(requestParameters, options) {
            return localVarFp.adminConfigurationsPartnerPartnerIdGet(requestParameters.partnerId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [FramingAdmin] Gets a configuration name, of a frameable product by productId
         * @param {AdminConfigurationApiAdminConfigurationsProductIdConfigurationNameGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminConfigurationsProductIdConfigurationNameGet(requestParameters, options) {
            return localVarFp.adminConfigurationsProductIdConfigurationNameGet(requestParameters.productId, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AdminConfigurationApi - object-oriented interface
 * @export
 * @class AdminConfigurationApi
 * @extends {BaseAPI}
 */
export class AdminConfigurationApi extends BaseAPI {
    /**
     * Set custom matchPlate PDF on a configuration
     * @param {AdminConfigurationApiAdminConfigurationsConfigurationIdCustomMatchplatePdfPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminConfigurationApi
     */
    adminConfigurationsConfigurationIdCustomMatchplatePdfPatch(requestParameters, options) {
        return AdminConfigurationApiFp(this.configuration).adminConfigurationsConfigurationIdCustomMatchplatePdfPatch(requestParameters.configurationId, requestParameters.temporaryUploadedUrl, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * a 404 from this endpoint can be considered a valid response. Not all Configurations have a Frame Configuration  We tried to do a 204 for when there is no Frame Configuration, but it did not generate correctly in the SDK
     * @param {AdminConfigurationApiAdminConfigurationsConfigurationIdFrameConfigurationGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminConfigurationApi
     */
    adminConfigurationsConfigurationIdFrameConfigurationGet(requestParameters, options) {
        return AdminConfigurationApiFp(this.configuration).adminConfigurationsConfigurationIdFrameConfigurationGet(requestParameters.configurationId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AdminConfigurationApiAdminConfigurationsConfigurationIdFrameConfigurationPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminConfigurationApi
     */
    adminConfigurationsConfigurationIdFrameConfigurationPatch(requestParameters, options) {
        return AdminConfigurationApiFp(this.configuration).adminConfigurationsConfigurationIdFrameConfigurationPatch(requestParameters.configurationId, requestParameters.adminConfigurationsConfigurationIdFrameConfigurationPatchRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [Admin] Updates the notes of a configuration
     * @param {AdminConfigurationApiAdminConfigurationsConfigurationIdNotesPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminConfigurationApi
     */
    adminConfigurationsConfigurationIdNotesPatch(requestParameters, options) {
        return AdminConfigurationApiFp(this.configuration).adminConfigurationsConfigurationIdNotesPatch(requestParameters.configurationId, requestParameters.adminConfigurationsConfigurationIdNotesPatchRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [Admin] Get configuration by ID
     * @param {AdminConfigurationApiAdminConfigurationsIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminConfigurationApi
     */
    adminConfigurationsIdGet(requestParameters, options) {
        return AdminConfigurationApiFp(this.configuration).adminConfigurationsIdGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update print settings on a configuration by id.
     * @param {AdminConfigurationApiAdminConfigurationsIdPrintSettingsPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminConfigurationApi
     */
    adminConfigurationsIdPrintSettingsPatch(requestParameters, options) {
        return AdminConfigurationApiFp(this.configuration).adminConfigurationsIdPrintSettingsPatch(requestParameters.id, requestParameters.adminConfigurationsIdPrintSettingsPatchRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update shipping type on a configuration by id.
     * @param {AdminConfigurationApiAdminConfigurationsIdShippingTypePatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminConfigurationApi
     */
    adminConfigurationsIdShippingTypePatch(requestParameters, options) {
        return AdminConfigurationApiFp(this.configuration).adminConfigurationsIdShippingTypePatch(requestParameters.id, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get all configurations by partner id.
     * @param {AdminConfigurationApiAdminConfigurationsPartnerPartnerIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminConfigurationApi
     */
    adminConfigurationsPartnerPartnerIdGet(requestParameters, options) {
        return AdminConfigurationApiFp(this.configuration).adminConfigurationsPartnerPartnerIdGet(requestParameters.partnerId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [FramingAdmin] Gets a configuration name, of a frameable product by productId
     * @param {AdminConfigurationApiAdminConfigurationsProductIdConfigurationNameGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminConfigurationApi
     */
    adminConfigurationsProductIdConfigurationNameGet(requestParameters, options) {
        return AdminConfigurationApiFp(this.configuration).adminConfigurationsProductIdConfigurationNameGet(requestParameters.productId, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * AdminConfigurationTemplateApi - axios parameter creator
 * @export
 */
export const AdminConfigurationTemplateApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary [Admin] Get all configuration templates by search term
         * @param {Array<PresetStatus>} [statuses]
         * @param {string} [searchTerm]
         * @param {string} [partnerId]
         * @param {boolean} [isArchived]
         * @param {'Ascending' | 'Descending'} [sortDirection]
         * @param {number} [offset]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminConfigurationTemplatesGet: (statuses, searchTerm, partnerId, isArchived, sortDirection, offset, pageSize, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/admin/configuration-templates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            if (statuses) {
                localVarQueryParameter['Statuses'] = statuses;
            }
            if (searchTerm !== undefined) {
                localVarQueryParameter['SearchTerm'] = searchTerm;
            }
            if (partnerId !== undefined) {
                localVarQueryParameter['PartnerId'] = partnerId;
            }
            if (isArchived !== undefined) {
                localVarQueryParameter['IsArchived'] = isArchived;
            }
            if (sortDirection !== undefined) {
                localVarQueryParameter['SortDirection'] = sortDirection;
            }
            if (offset !== undefined) {
                localVarQueryParameter['Offset'] = offset;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['PageSize'] = pageSize;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [FramingAdmin] Links a configuration template to a product
         * @param {string} id
         * @param {string} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminConfigurationTemplatesIdApplyConfigurationPatch: (id, body, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminConfigurationTemplatesIdApplyConfigurationPatch', 'id', id);
            const localVarPath = `/admin/configuration-templates/{id}/apply-configuration`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [Admin] Create a configuration template
         * @param {AdminConfigurationTemplatesPostRequest} [adminConfigurationTemplatesPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminConfigurationTemplatesPost: (adminConfigurationTemplatesPostRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/admin/configuration-templates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(adminConfigurationTemplatesPostRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [FramingAdmin] Deletes a preset
         * @param {string} presetId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminConfigurationTemplatesPresetIdDelete: (presetId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'presetId' is not null or undefined
            assertParamExists('adminConfigurationTemplatesPresetIdDelete', 'presetId', presetId);
            const localVarPath = `/admin/configuration-templates/{presetId}`
                .replace(`{${"presetId"}}`, encodeURIComponent(String(presetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [Admin] Create a configuration template for a frameable product
         * @param {string} frameableProductId
         * @param {AdminFrameableProductsFrameableProductIdConfigurationTemplatesPostRequest} [adminFrameableProductsFrameableProductIdConfigurationTemplatesPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFrameableProductsFrameableProductIdConfigurationTemplatesPost: (frameableProductId, adminFrameableProductsFrameableProductIdConfigurationTemplatesPostRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'frameableProductId' is not null or undefined
            assertParamExists('adminFrameableProductsFrameableProductIdConfigurationTemplatesPost', 'frameableProductId', frameableProductId);
            const localVarPath = `/admin/frameable-products/{frameableProductId}/configuration-templates`
                .replace(`{${"frameableProductId"}}`, encodeURIComponent(String(frameableProductId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(adminFrameableProductsFrameableProductIdConfigurationTemplatesPostRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [Admin] List configuration templates for a frameable product
         * @param {Array<PresetStatus>} [statuses]
         * @param {string} [searchTerm]
         * @param {string} [frameableProductId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPresetsGet: (statuses, searchTerm, frameableProductId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/admin/presets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            if (statuses) {
                localVarQueryParameter['Statuses'] = statuses;
            }
            if (searchTerm !== undefined) {
                localVarQueryParameter['SearchTerm'] = searchTerm;
            }
            if (frameableProductId !== undefined) {
                localVarQueryParameter['FrameableProductId'] = frameableProductId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Duplicate a configuration template by id.
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPresetsIdDuplicatePost: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminPresetsIdDuplicatePost', 'id', id);
            const localVarPath = `/admin/presets/{id}/duplicate`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [Admin] Get a configuration template by id
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPresetsIdGet: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminPresetsIdGet', 'id', id);
            const localVarPath = `/admin/presets/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [Admin] Update a configuration template
         * @param {string} id
         * @param {AdminPresetsIdPatchRequest} [adminPresetsIdPatchRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPresetsIdPatch: (id, adminPresetsIdPatchRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminPresetsIdPatch', 'id', id);
            const localVarPath = `/admin/presets/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(adminPresetsIdPatchRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * AdminConfigurationTemplateApi - functional programming interface
 * @export
 */
export const AdminConfigurationTemplateApiFp = function (configuration) {
    const localVarAxiosParamCreator = AdminConfigurationTemplateApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary [Admin] Get all configuration templates by search term
         * @param {Array<PresetStatus>} [statuses]
         * @param {string} [searchTerm]
         * @param {string} [partnerId]
         * @param {boolean} [isArchived]
         * @param {'Ascending' | 'Descending'} [sortDirection]
         * @param {number} [offset]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminConfigurationTemplatesGet(statuses, searchTerm, partnerId, isArchived, sortDirection, offset, pageSize, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminConfigurationTemplatesGet(statuses, searchTerm, partnerId, isArchived, sortDirection, offset, pageSize, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [FramingAdmin] Links a configuration template to a product
         * @param {string} id
         * @param {string} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminConfigurationTemplatesIdApplyConfigurationPatch(id, body, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminConfigurationTemplatesIdApplyConfigurationPatch(id, body, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [Admin] Create a configuration template
         * @param {AdminConfigurationTemplatesPostRequest} [adminConfigurationTemplatesPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminConfigurationTemplatesPost(adminConfigurationTemplatesPostRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminConfigurationTemplatesPost(adminConfigurationTemplatesPostRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [FramingAdmin] Deletes a preset
         * @param {string} presetId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminConfigurationTemplatesPresetIdDelete(presetId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminConfigurationTemplatesPresetIdDelete(presetId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [Admin] Create a configuration template for a frameable product
         * @param {string} frameableProductId
         * @param {AdminFrameableProductsFrameableProductIdConfigurationTemplatesPostRequest} [adminFrameableProductsFrameableProductIdConfigurationTemplatesPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFrameableProductsFrameableProductIdConfigurationTemplatesPost(frameableProductId, adminFrameableProductsFrameableProductIdConfigurationTemplatesPostRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminFrameableProductsFrameableProductIdConfigurationTemplatesPost(frameableProductId, adminFrameableProductsFrameableProductIdConfigurationTemplatesPostRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [Admin] List configuration templates for a frameable product
         * @param {Array<PresetStatus>} [statuses]
         * @param {string} [searchTerm]
         * @param {string} [frameableProductId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPresetsGet(statuses, searchTerm, frameableProductId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminPresetsGet(statuses, searchTerm, frameableProductId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Duplicate a configuration template by id.
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPresetsIdDuplicatePost(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminPresetsIdDuplicatePost(id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [Admin] Get a configuration template by id
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPresetsIdGet(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminPresetsIdGet(id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [Admin] Update a configuration template
         * @param {string} id
         * @param {AdminPresetsIdPatchRequest} [adminPresetsIdPatchRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPresetsIdPatch(id, adminPresetsIdPatchRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminPresetsIdPatch(id, adminPresetsIdPatchRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * AdminConfigurationTemplateApi - factory interface
 * @export
 */
export const AdminConfigurationTemplateApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AdminConfigurationTemplateApiFp(configuration);
    return {
        /**
         *
         * @summary [Admin] Get all configuration templates by search term
         * @param {AdminConfigurationTemplateApiAdminConfigurationTemplatesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminConfigurationTemplatesGet(requestParameters = {}, options) {
            return localVarFp.adminConfigurationTemplatesGet(requestParameters.statuses, requestParameters.searchTerm, requestParameters.partnerId, requestParameters.isArchived, requestParameters.sortDirection, requestParameters.offset, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [FramingAdmin] Links a configuration template to a product
         * @param {AdminConfigurationTemplateApiAdminConfigurationTemplatesIdApplyConfigurationPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminConfigurationTemplatesIdApplyConfigurationPatch(requestParameters, options) {
            return localVarFp.adminConfigurationTemplatesIdApplyConfigurationPatch(requestParameters.id, requestParameters.body, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [Admin] Create a configuration template
         * @param {AdminConfigurationTemplateApiAdminConfigurationTemplatesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminConfigurationTemplatesPost(requestParameters = {}, options) {
            return localVarFp.adminConfigurationTemplatesPost(requestParameters.adminConfigurationTemplatesPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [FramingAdmin] Deletes a preset
         * @param {AdminConfigurationTemplateApiAdminConfigurationTemplatesPresetIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminConfigurationTemplatesPresetIdDelete(requestParameters, options) {
            return localVarFp.adminConfigurationTemplatesPresetIdDelete(requestParameters.presetId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [Admin] Create a configuration template for a frameable product
         * @param {AdminConfigurationTemplateApiAdminFrameableProductsFrameableProductIdConfigurationTemplatesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFrameableProductsFrameableProductIdConfigurationTemplatesPost(requestParameters, options) {
            return localVarFp.adminFrameableProductsFrameableProductIdConfigurationTemplatesPost(requestParameters.frameableProductId, requestParameters.adminFrameableProductsFrameableProductIdConfigurationTemplatesPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [Admin] List configuration templates for a frameable product
         * @param {AdminConfigurationTemplateApiAdminPresetsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPresetsGet(requestParameters = {}, options) {
            return localVarFp.adminPresetsGet(requestParameters.statuses, requestParameters.searchTerm, requestParameters.frameableProductId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Duplicate a configuration template by id.
         * @param {AdminConfigurationTemplateApiAdminPresetsIdDuplicatePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPresetsIdDuplicatePost(requestParameters, options) {
            return localVarFp.adminPresetsIdDuplicatePost(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [Admin] Get a configuration template by id
         * @param {AdminConfigurationTemplateApiAdminPresetsIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPresetsIdGet(requestParameters, options) {
            return localVarFp.adminPresetsIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [Admin] Update a configuration template
         * @param {AdminConfigurationTemplateApiAdminPresetsIdPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPresetsIdPatch(requestParameters, options) {
            return localVarFp.adminPresetsIdPatch(requestParameters.id, requestParameters.adminPresetsIdPatchRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AdminConfigurationTemplateApi - object-oriented interface
 * @export
 * @class AdminConfigurationTemplateApi
 * @extends {BaseAPI}
 */
export class AdminConfigurationTemplateApi extends BaseAPI {
    /**
     *
     * @summary [Admin] Get all configuration templates by search term
     * @param {AdminConfigurationTemplateApiAdminConfigurationTemplatesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminConfigurationTemplateApi
     */
    adminConfigurationTemplatesGet(requestParameters = {}, options) {
        return AdminConfigurationTemplateApiFp(this.configuration).adminConfigurationTemplatesGet(requestParameters.statuses, requestParameters.searchTerm, requestParameters.partnerId, requestParameters.isArchived, requestParameters.sortDirection, requestParameters.offset, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [FramingAdmin] Links a configuration template to a product
     * @param {AdminConfigurationTemplateApiAdminConfigurationTemplatesIdApplyConfigurationPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminConfigurationTemplateApi
     */
    adminConfigurationTemplatesIdApplyConfigurationPatch(requestParameters, options) {
        return AdminConfigurationTemplateApiFp(this.configuration).adminConfigurationTemplatesIdApplyConfigurationPatch(requestParameters.id, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [Admin] Create a configuration template
     * @param {AdminConfigurationTemplateApiAdminConfigurationTemplatesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminConfigurationTemplateApi
     */
    adminConfigurationTemplatesPost(requestParameters = {}, options) {
        return AdminConfigurationTemplateApiFp(this.configuration).adminConfigurationTemplatesPost(requestParameters.adminConfigurationTemplatesPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [FramingAdmin] Deletes a preset
     * @param {AdminConfigurationTemplateApiAdminConfigurationTemplatesPresetIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminConfigurationTemplateApi
     */
    adminConfigurationTemplatesPresetIdDelete(requestParameters, options) {
        return AdminConfigurationTemplateApiFp(this.configuration).adminConfigurationTemplatesPresetIdDelete(requestParameters.presetId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [Admin] Create a configuration template for a frameable product
     * @param {AdminConfigurationTemplateApiAdminFrameableProductsFrameableProductIdConfigurationTemplatesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminConfigurationTemplateApi
     */
    adminFrameableProductsFrameableProductIdConfigurationTemplatesPost(requestParameters, options) {
        return AdminConfigurationTemplateApiFp(this.configuration).adminFrameableProductsFrameableProductIdConfigurationTemplatesPost(requestParameters.frameableProductId, requestParameters.adminFrameableProductsFrameableProductIdConfigurationTemplatesPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [Admin] List configuration templates for a frameable product
     * @param {AdminConfigurationTemplateApiAdminPresetsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminConfigurationTemplateApi
     */
    adminPresetsGet(requestParameters = {}, options) {
        return AdminConfigurationTemplateApiFp(this.configuration).adminPresetsGet(requestParameters.statuses, requestParameters.searchTerm, requestParameters.frameableProductId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Duplicate a configuration template by id.
     * @param {AdminConfigurationTemplateApiAdminPresetsIdDuplicatePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminConfigurationTemplateApi
     */
    adminPresetsIdDuplicatePost(requestParameters, options) {
        return AdminConfigurationTemplateApiFp(this.configuration).adminPresetsIdDuplicatePost(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [Admin] Get a configuration template by id
     * @param {AdminConfigurationTemplateApiAdminPresetsIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminConfigurationTemplateApi
     */
    adminPresetsIdGet(requestParameters, options) {
        return AdminConfigurationTemplateApiFp(this.configuration).adminPresetsIdGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [Admin] Update a configuration template
     * @param {AdminConfigurationTemplateApiAdminPresetsIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminConfigurationTemplateApi
     */
    adminPresetsIdPatch(requestParameters, options) {
        return AdminConfigurationTemplateApiFp(this.configuration).adminPresetsIdPatch(requestParameters.id, requestParameters.adminPresetsIdPatchRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * AdminFeatureOptionApi - axios parameter creator
 * @export
 */
export const AdminFeatureOptionApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Delete a feature option of the specific feature type.
         * @param {string} featureOptionId
         * @param {'Frame' | 'Glass' | 'Lighting' | 'Matchplate' | 'MatchplateExtras' | 'PassePartout' | 'Shipping' | 'Fold' | 'Sleeves' | 'ClubLogo' | 'Photos'} [featureType]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featureOptionsFeatureOptionIdDelete: (featureOptionId, featureType, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'featureOptionId' is not null or undefined
            assertParamExists('featureOptionsFeatureOptionIdDelete', 'featureOptionId', featureOptionId);
            const localVarPath = `/feature-options/{featureOptionId}`
                .replace(`{${"featureOptionId"}}`, encodeURIComponent(String(featureOptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            if (featureType !== undefined) {
                localVarQueryParameter['featureType'] = featureType;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Updates a feature option of the specific feature type.
         * @param {string} featureOptionId
         * @param {FeatureOptionsPostRequest} [featureOptionsPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featureOptionsFeatureOptionIdPut: (featureOptionId, featureOptionsPostRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'featureOptionId' is not null or undefined
            assertParamExists('featureOptionsFeatureOptionIdPut', 'featureOptionId', featureOptionId);
            const localVarPath = `/feature-options/{featureOptionId}`
                .replace(`{${"featureOptionId"}}`, encodeURIComponent(String(featureOptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(featureOptionsPostRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Creates a new feature option of the specific feature type.
         * @param {'Frame' | 'Glass' | 'Lighting' | 'Matchplate' | 'MatchplateExtras' | 'PassePartout' | 'Shipping' | 'Fold' | 'Sleeves' | 'ClubLogo' | 'Photos'} [featureType]
         * @param {FeatureOptionsPostRequest} [featureOptionsPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featureOptionsPost: (featureType, featureOptionsPostRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/feature-options`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            if (featureType !== undefined) {
                localVarQueryParameter['featureType'] = featureType;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(featureOptionsPostRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * AdminFeatureOptionApi - functional programming interface
 * @export
 */
export const AdminFeatureOptionApiFp = function (configuration) {
    const localVarAxiosParamCreator = AdminFeatureOptionApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Delete a feature option of the specific feature type.
         * @param {string} featureOptionId
         * @param {'Frame' | 'Glass' | 'Lighting' | 'Matchplate' | 'MatchplateExtras' | 'PassePartout' | 'Shipping' | 'Fold' | 'Sleeves' | 'ClubLogo' | 'Photos'} [featureType]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featureOptionsFeatureOptionIdDelete(featureOptionId, featureType, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.featureOptionsFeatureOptionIdDelete(featureOptionId, featureType, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Updates a feature option of the specific feature type.
         * @param {string} featureOptionId
         * @param {FeatureOptionsPostRequest} [featureOptionsPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featureOptionsFeatureOptionIdPut(featureOptionId, featureOptionsPostRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.featureOptionsFeatureOptionIdPut(featureOptionId, featureOptionsPostRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Creates a new feature option of the specific feature type.
         * @param {'Frame' | 'Glass' | 'Lighting' | 'Matchplate' | 'MatchplateExtras' | 'PassePartout' | 'Shipping' | 'Fold' | 'Sleeves' | 'ClubLogo' | 'Photos'} [featureType]
         * @param {FeatureOptionsPostRequest} [featureOptionsPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featureOptionsPost(featureType, featureOptionsPostRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.featureOptionsPost(featureType, featureOptionsPostRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * AdminFeatureOptionApi - factory interface
 * @export
 */
export const AdminFeatureOptionApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AdminFeatureOptionApiFp(configuration);
    return {
        /**
         *
         * @summary Delete a feature option of the specific feature type.
         * @param {AdminFeatureOptionApiFeatureOptionsFeatureOptionIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featureOptionsFeatureOptionIdDelete(requestParameters, options) {
            return localVarFp.featureOptionsFeatureOptionIdDelete(requestParameters.featureOptionId, requestParameters.featureType, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Updates a feature option of the specific feature type.
         * @param {AdminFeatureOptionApiFeatureOptionsFeatureOptionIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featureOptionsFeatureOptionIdPut(requestParameters, options) {
            return localVarFp.featureOptionsFeatureOptionIdPut(requestParameters.featureOptionId, requestParameters.featureOptionsPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Creates a new feature option of the specific feature type.
         * @param {AdminFeatureOptionApiFeatureOptionsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featureOptionsPost(requestParameters = {}, options) {
            return localVarFp.featureOptionsPost(requestParameters.featureType, requestParameters.featureOptionsPostRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AdminFeatureOptionApi - object-oriented interface
 * @export
 * @class AdminFeatureOptionApi
 * @extends {BaseAPI}
 */
export class AdminFeatureOptionApi extends BaseAPI {
    /**
     *
     * @summary Delete a feature option of the specific feature type.
     * @param {AdminFeatureOptionApiFeatureOptionsFeatureOptionIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminFeatureOptionApi
     */
    featureOptionsFeatureOptionIdDelete(requestParameters, options) {
        return AdminFeatureOptionApiFp(this.configuration).featureOptionsFeatureOptionIdDelete(requestParameters.featureOptionId, requestParameters.featureType, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Updates a feature option of the specific feature type.
     * @param {AdminFeatureOptionApiFeatureOptionsFeatureOptionIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminFeatureOptionApi
     */
    featureOptionsFeatureOptionIdPut(requestParameters, options) {
        return AdminFeatureOptionApiFp(this.configuration).featureOptionsFeatureOptionIdPut(requestParameters.featureOptionId, requestParameters.featureOptionsPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Creates a new feature option of the specific feature type.
     * @param {AdminFeatureOptionApiFeatureOptionsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminFeatureOptionApi
     */
    featureOptionsPost(requestParameters = {}, options) {
        return AdminFeatureOptionApiFp(this.configuration).featureOptionsPost(requestParameters.featureType, requestParameters.featureOptionsPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * AdminFrameableProductApi - axios parameter creator
 * @export
 */
export const AdminFrameableProductApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary [FramingAdmin] Upload a club logo for a frameable product
         * @param {string} externalId
         * @param {AdminFrameableProductsExternalIdClubLogoPatchRequest} [adminFrameableProductsExternalIdClubLogoPatchRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFrameableProductsExternalIdClubLogoPatch: (externalId, adminFrameableProductsExternalIdClubLogoPatchRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'externalId' is not null or undefined
            assertParamExists('adminFrameableProductsExternalIdClubLogoPatch', 'externalId', externalId);
            const localVarPath = `/admin/frameable-products/{externalId}/club-logo`
                .replace(`{${"externalId"}}`, encodeURIComponent(String(externalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(adminFrameableProductsExternalIdClubLogoPatchRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Removes club logo from frameable product.
         * @param {string} externalId External Id of the frameable product
         * @param {AdminFrameableProductsExternalIdClubLogoRemovePatchRequest} [adminFrameableProductsExternalIdClubLogoRemovePatchRequest] Request containing the unique link of the club logo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFrameableProductsExternalIdClubLogoRemovePatch: (externalId, adminFrameableProductsExternalIdClubLogoRemovePatchRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'externalId' is not null or undefined
            assertParamExists('adminFrameableProductsExternalIdClubLogoRemovePatch', 'externalId', externalId);
            const localVarPath = `/admin/frameable-products/{externalId}/club-logo/remove`
                .replace(`{${"externalId"}}`, encodeURIComponent(String(externalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(adminFrameableProductsExternalIdClubLogoRemovePatchRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get frameable product by id
         * @param {string} frameableProductId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFrameableProductsFrameableProductIdGet: (frameableProductId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'frameableProductId' is not null or undefined
            assertParamExists('adminFrameableProductsFrameableProductIdGet', 'frameableProductId', frameableProductId);
            const localVarPath = `/admin/frameable-products/{frameableProductId}`
                .replace(`{${"frameableProductId"}}`, encodeURIComponent(String(frameableProductId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Update a frameable product from Admin.
         * @param {string} frameableProductId
         * @param {AdminFrameableProductsFrameableProductIdPutRequest} [adminFrameableProductsFrameableProductIdPutRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFrameableProductsFrameableProductIdPut: (frameableProductId, adminFrameableProductsFrameableProductIdPutRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'frameableProductId' is not null or undefined
            assertParamExists('adminFrameableProductsFrameableProductIdPut', 'frameableProductId', frameableProductId);
            const localVarPath = `/admin/frameable-products/{frameableProductId}`
                .replace(`{${"frameableProductId"}}`, encodeURIComponent(String(frameableProductId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(adminFrameableProductsFrameableProductIdPutRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [FramingAdmin] Get a frameable product by external id.
         * @param {string} [externalId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFrameableProductsGet: (externalId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/admin/frameable-products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            if (externalId !== undefined) {
                localVarQueryParameter['externalId'] = externalId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [FramingAdmin] Save passe-partout image urls for a frameable product
         * @param {AdminFrameableProductsPassePartoutPatchRequest} [adminFrameableProductsPassePartoutPatchRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFrameableProductsPassePartoutPatch: (adminFrameableProductsPassePartoutPatchRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/admin/frameable-products/passe-partout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(adminFrameableProductsPassePartoutPatchRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * AdminFrameableProductApi - functional programming interface
 * @export
 */
export const AdminFrameableProductApiFp = function (configuration) {
    const localVarAxiosParamCreator = AdminFrameableProductApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary [FramingAdmin] Upload a club logo for a frameable product
         * @param {string} externalId
         * @param {AdminFrameableProductsExternalIdClubLogoPatchRequest} [adminFrameableProductsExternalIdClubLogoPatchRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFrameableProductsExternalIdClubLogoPatch(externalId, adminFrameableProductsExternalIdClubLogoPatchRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminFrameableProductsExternalIdClubLogoPatch(externalId, adminFrameableProductsExternalIdClubLogoPatchRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Removes club logo from frameable product.
         * @param {string} externalId External Id of the frameable product
         * @param {AdminFrameableProductsExternalIdClubLogoRemovePatchRequest} [adminFrameableProductsExternalIdClubLogoRemovePatchRequest] Request containing the unique link of the club logo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFrameableProductsExternalIdClubLogoRemovePatch(externalId, adminFrameableProductsExternalIdClubLogoRemovePatchRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminFrameableProductsExternalIdClubLogoRemovePatch(externalId, adminFrameableProductsExternalIdClubLogoRemovePatchRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get frameable product by id
         * @param {string} frameableProductId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFrameableProductsFrameableProductIdGet(frameableProductId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminFrameableProductsFrameableProductIdGet(frameableProductId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Update a frameable product from Admin.
         * @param {string} frameableProductId
         * @param {AdminFrameableProductsFrameableProductIdPutRequest} [adminFrameableProductsFrameableProductIdPutRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFrameableProductsFrameableProductIdPut(frameableProductId, adminFrameableProductsFrameableProductIdPutRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminFrameableProductsFrameableProductIdPut(frameableProductId, adminFrameableProductsFrameableProductIdPutRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [FramingAdmin] Get a frameable product by external id.
         * @param {string} [externalId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFrameableProductsGet(externalId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminFrameableProductsGet(externalId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [FramingAdmin] Save passe-partout image urls for a frameable product
         * @param {AdminFrameableProductsPassePartoutPatchRequest} [adminFrameableProductsPassePartoutPatchRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFrameableProductsPassePartoutPatch(adminFrameableProductsPassePartoutPatchRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminFrameableProductsPassePartoutPatch(adminFrameableProductsPassePartoutPatchRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * AdminFrameableProductApi - factory interface
 * @export
 */
export const AdminFrameableProductApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AdminFrameableProductApiFp(configuration);
    return {
        /**
         *
         * @summary [FramingAdmin] Upload a club logo for a frameable product
         * @param {AdminFrameableProductApiAdminFrameableProductsExternalIdClubLogoPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFrameableProductsExternalIdClubLogoPatch(requestParameters, options) {
            return localVarFp.adminFrameableProductsExternalIdClubLogoPatch(requestParameters.externalId, requestParameters.adminFrameableProductsExternalIdClubLogoPatchRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Removes club logo from frameable product.
         * @param {AdminFrameableProductApiAdminFrameableProductsExternalIdClubLogoRemovePatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFrameableProductsExternalIdClubLogoRemovePatch(requestParameters, options) {
            return localVarFp.adminFrameableProductsExternalIdClubLogoRemovePatch(requestParameters.externalId, requestParameters.adminFrameableProductsExternalIdClubLogoRemovePatchRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get frameable product by id
         * @param {AdminFrameableProductApiAdminFrameableProductsFrameableProductIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFrameableProductsFrameableProductIdGet(requestParameters, options) {
            return localVarFp.adminFrameableProductsFrameableProductIdGet(requestParameters.frameableProductId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update a frameable product from Admin.
         * @param {AdminFrameableProductApiAdminFrameableProductsFrameableProductIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFrameableProductsFrameableProductIdPut(requestParameters, options) {
            return localVarFp.adminFrameableProductsFrameableProductIdPut(requestParameters.frameableProductId, requestParameters.adminFrameableProductsFrameableProductIdPutRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [FramingAdmin] Get a frameable product by external id.
         * @param {AdminFrameableProductApiAdminFrameableProductsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFrameableProductsGet(requestParameters = {}, options) {
            return localVarFp.adminFrameableProductsGet(requestParameters.externalId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [FramingAdmin] Save passe-partout image urls for a frameable product
         * @param {AdminFrameableProductApiAdminFrameableProductsPassePartoutPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFrameableProductsPassePartoutPatch(requestParameters = {}, options) {
            return localVarFp.adminFrameableProductsPassePartoutPatch(requestParameters.adminFrameableProductsPassePartoutPatchRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AdminFrameableProductApi - object-oriented interface
 * @export
 * @class AdminFrameableProductApi
 * @extends {BaseAPI}
 */
export class AdminFrameableProductApi extends BaseAPI {
    /**
     *
     * @summary [FramingAdmin] Upload a club logo for a frameable product
     * @param {AdminFrameableProductApiAdminFrameableProductsExternalIdClubLogoPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminFrameableProductApi
     */
    adminFrameableProductsExternalIdClubLogoPatch(requestParameters, options) {
        return AdminFrameableProductApiFp(this.configuration).adminFrameableProductsExternalIdClubLogoPatch(requestParameters.externalId, requestParameters.adminFrameableProductsExternalIdClubLogoPatchRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Removes club logo from frameable product.
     * @param {AdminFrameableProductApiAdminFrameableProductsExternalIdClubLogoRemovePatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminFrameableProductApi
     */
    adminFrameableProductsExternalIdClubLogoRemovePatch(requestParameters, options) {
        return AdminFrameableProductApiFp(this.configuration).adminFrameableProductsExternalIdClubLogoRemovePatch(requestParameters.externalId, requestParameters.adminFrameableProductsExternalIdClubLogoRemovePatchRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get frameable product by id
     * @param {AdminFrameableProductApiAdminFrameableProductsFrameableProductIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminFrameableProductApi
     */
    adminFrameableProductsFrameableProductIdGet(requestParameters, options) {
        return AdminFrameableProductApiFp(this.configuration).adminFrameableProductsFrameableProductIdGet(requestParameters.frameableProductId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update a frameable product from Admin.
     * @param {AdminFrameableProductApiAdminFrameableProductsFrameableProductIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminFrameableProductApi
     */
    adminFrameableProductsFrameableProductIdPut(requestParameters, options) {
        return AdminFrameableProductApiFp(this.configuration).adminFrameableProductsFrameableProductIdPut(requestParameters.frameableProductId, requestParameters.adminFrameableProductsFrameableProductIdPutRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [FramingAdmin] Get a frameable product by external id.
     * @param {AdminFrameableProductApiAdminFrameableProductsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminFrameableProductApi
     */
    adminFrameableProductsGet(requestParameters = {}, options) {
        return AdminFrameableProductApiFp(this.configuration).adminFrameableProductsGet(requestParameters.externalId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [FramingAdmin] Save passe-partout image urls for a frameable product
     * @param {AdminFrameableProductApiAdminFrameableProductsPassePartoutPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminFrameableProductApi
     */
    adminFrameableProductsPassePartoutPatch(requestParameters = {}, options) {
        return AdminFrameableProductApiFp(this.configuration).adminFrameableProductsPassePartoutPatch(requestParameters.adminFrameableProductsPassePartoutPatchRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * AdminFrameableProductPassepartoutImagePublicationApi - axios parameter creator
 * @export
 */
export const AdminFrameableProductPassepartoutImagePublicationApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Update a frameable product passepartout publications from Admin.
         * @param {AdminFrameableProductPassepartoutPublicationPutRequest} [adminFrameableProductPassepartoutPublicationPutRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFrameableProductPassepartoutPublicationPut: (adminFrameableProductPassepartoutPublicationPutRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/admin/frameable-product-passepartout-publication`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(adminFrameableProductPassepartoutPublicationPutRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * AdminFrameableProductPassepartoutImagePublicationApi - functional programming interface
 * @export
 */
export const AdminFrameableProductPassepartoutImagePublicationApiFp = function (configuration) {
    const localVarAxiosParamCreator = AdminFrameableProductPassepartoutImagePublicationApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Update a frameable product passepartout publications from Admin.
         * @param {AdminFrameableProductPassepartoutPublicationPutRequest} [adminFrameableProductPassepartoutPublicationPutRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFrameableProductPassepartoutPublicationPut(adminFrameableProductPassepartoutPublicationPutRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminFrameableProductPassepartoutPublicationPut(adminFrameableProductPassepartoutPublicationPutRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * AdminFrameableProductPassepartoutImagePublicationApi - factory interface
 * @export
 */
export const AdminFrameableProductPassepartoutImagePublicationApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AdminFrameableProductPassepartoutImagePublicationApiFp(configuration);
    return {
        /**
         *
         * @summary Update a frameable product passepartout publications from Admin.
         * @param {AdminFrameableProductPassepartoutImagePublicationApiAdminFrameableProductPassepartoutPublicationPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFrameableProductPassepartoutPublicationPut(requestParameters = {}, options) {
            return localVarFp.adminFrameableProductPassepartoutPublicationPut(requestParameters.adminFrameableProductPassepartoutPublicationPutRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AdminFrameableProductPassepartoutImagePublicationApi - object-oriented interface
 * @export
 * @class AdminFrameableProductPassepartoutImagePublicationApi
 * @extends {BaseAPI}
 */
export class AdminFrameableProductPassepartoutImagePublicationApi extends BaseAPI {
    /**
     *
     * @summary Update a frameable product passepartout publications from Admin.
     * @param {AdminFrameableProductPassepartoutImagePublicationApiAdminFrameableProductPassepartoutPublicationPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminFrameableProductPassepartoutImagePublicationApi
     */
    adminFrameableProductPassepartoutPublicationPut(requestParameters = {}, options) {
        return AdminFrameableProductPassepartoutImagePublicationApiFp(this.configuration).adminFrameableProductPassepartoutPublicationPut(requestParameters.adminFrameableProductPassepartoutPublicationPutRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * AdminMockupSetApi - axios parameter creator
 * @export
 */
export const AdminMockupSetApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary [Admin] get the default mockup set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminMockupSetsDefaultGet: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/admin/mockup-sets/default`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [Admin] Get a paginated list of mockup sets.
         * @param {string} [searchTerm]
         * @param {number} [pageSize]
         * @param {number} [offset]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminMockupSetsGet: (searchTerm, pageSize, offset, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/admin/mockup-sets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            if (searchTerm !== undefined) {
                localVarQueryParameter['searchTerm'] = searchTerm;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [Admin] Update a mockup set
         * @param {string} id
         * @param {AdminMockupSetsIdPutRequest} [adminMockupSetsIdPutRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminMockupSetsIdPut: (id, adminMockupSetsIdPutRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminMockupSetsIdPut', 'id', id);
            const localVarPath = `/admin/mockup-sets/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(adminMockupSetsIdPutRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [Admin] set a mockup set as the default one and others as non default
         * @param {string} mockupSetId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminMockupSetsMockupSetIdDefaultPatch: (mockupSetId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'mockupSetId' is not null or undefined
            assertParamExists('adminMockupSetsMockupSetIdDefaultPatch', 'mockupSetId', mockupSetId);
            const localVarPath = `/admin/mockup-sets/{mockupSetId}/default`
                .replace(`{${"mockupSetId"}}`, encodeURIComponent(String(mockupSetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [Admin] Get mockup set by id
         * @param {string} mockupSetId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminMockupSetsMockupSetIdGet: (mockupSetId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'mockupSetId' is not null or undefined
            assertParamExists('adminMockupSetsMockupSetIdGet', 'mockupSetId', mockupSetId);
            const localVarPath = `/admin/mockup-sets/{mockupSetId}`
                .replace(`{${"mockupSetId"}}`, encodeURIComponent(String(mockupSetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [Admin] create a mockup set
         * @param {AdminMockupSetsPostRequest} [adminMockupSetsPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminMockupSetsPost: (adminMockupSetsPostRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/admin/mockup-sets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(adminMockupSetsPostRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * AdminMockupSetApi - functional programming interface
 * @export
 */
export const AdminMockupSetApiFp = function (configuration) {
    const localVarAxiosParamCreator = AdminMockupSetApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary [Admin] get the default mockup set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminMockupSetsDefaultGet(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminMockupSetsDefaultGet(options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [Admin] Get a paginated list of mockup sets.
         * @param {string} [searchTerm]
         * @param {number} [pageSize]
         * @param {number} [offset]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminMockupSetsGet(searchTerm, pageSize, offset, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminMockupSetsGet(searchTerm, pageSize, offset, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [Admin] Update a mockup set
         * @param {string} id
         * @param {AdminMockupSetsIdPutRequest} [adminMockupSetsIdPutRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminMockupSetsIdPut(id, adminMockupSetsIdPutRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminMockupSetsIdPut(id, adminMockupSetsIdPutRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [Admin] set a mockup set as the default one and others as non default
         * @param {string} mockupSetId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminMockupSetsMockupSetIdDefaultPatch(mockupSetId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminMockupSetsMockupSetIdDefaultPatch(mockupSetId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [Admin] Get mockup set by id
         * @param {string} mockupSetId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminMockupSetsMockupSetIdGet(mockupSetId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminMockupSetsMockupSetIdGet(mockupSetId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [Admin] create a mockup set
         * @param {AdminMockupSetsPostRequest} [adminMockupSetsPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminMockupSetsPost(adminMockupSetsPostRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminMockupSetsPost(adminMockupSetsPostRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * AdminMockupSetApi - factory interface
 * @export
 */
export const AdminMockupSetApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AdminMockupSetApiFp(configuration);
    return {
        /**
         *
         * @summary [Admin] get the default mockup set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminMockupSetsDefaultGet(options) {
            return localVarFp.adminMockupSetsDefaultGet(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [Admin] Get a paginated list of mockup sets.
         * @param {AdminMockupSetApiAdminMockupSetsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminMockupSetsGet(requestParameters = {}, options) {
            return localVarFp.adminMockupSetsGet(requestParameters.searchTerm, requestParameters.pageSize, requestParameters.offset, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [Admin] Update a mockup set
         * @param {AdminMockupSetApiAdminMockupSetsIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminMockupSetsIdPut(requestParameters, options) {
            return localVarFp.adminMockupSetsIdPut(requestParameters.id, requestParameters.adminMockupSetsIdPutRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [Admin] set a mockup set as the default one and others as non default
         * @param {AdminMockupSetApiAdminMockupSetsMockupSetIdDefaultPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminMockupSetsMockupSetIdDefaultPatch(requestParameters, options) {
            return localVarFp.adminMockupSetsMockupSetIdDefaultPatch(requestParameters.mockupSetId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [Admin] Get mockup set by id
         * @param {AdminMockupSetApiAdminMockupSetsMockupSetIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminMockupSetsMockupSetIdGet(requestParameters, options) {
            return localVarFp.adminMockupSetsMockupSetIdGet(requestParameters.mockupSetId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [Admin] create a mockup set
         * @param {AdminMockupSetApiAdminMockupSetsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminMockupSetsPost(requestParameters = {}, options) {
            return localVarFp.adminMockupSetsPost(requestParameters.adminMockupSetsPostRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AdminMockupSetApi - object-oriented interface
 * @export
 * @class AdminMockupSetApi
 * @extends {BaseAPI}
 */
export class AdminMockupSetApi extends BaseAPI {
    /**
     *
     * @summary [Admin] get the default mockup set
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminMockupSetApi
     */
    adminMockupSetsDefaultGet(options) {
        return AdminMockupSetApiFp(this.configuration).adminMockupSetsDefaultGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [Admin] Get a paginated list of mockup sets.
     * @param {AdminMockupSetApiAdminMockupSetsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminMockupSetApi
     */
    adminMockupSetsGet(requestParameters = {}, options) {
        return AdminMockupSetApiFp(this.configuration).adminMockupSetsGet(requestParameters.searchTerm, requestParameters.pageSize, requestParameters.offset, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [Admin] Update a mockup set
     * @param {AdminMockupSetApiAdminMockupSetsIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminMockupSetApi
     */
    adminMockupSetsIdPut(requestParameters, options) {
        return AdminMockupSetApiFp(this.configuration).adminMockupSetsIdPut(requestParameters.id, requestParameters.adminMockupSetsIdPutRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [Admin] set a mockup set as the default one and others as non default
     * @param {AdminMockupSetApiAdminMockupSetsMockupSetIdDefaultPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminMockupSetApi
     */
    adminMockupSetsMockupSetIdDefaultPatch(requestParameters, options) {
        return AdminMockupSetApiFp(this.configuration).adminMockupSetsMockupSetIdDefaultPatch(requestParameters.mockupSetId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [Admin] Get mockup set by id
     * @param {AdminMockupSetApiAdminMockupSetsMockupSetIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminMockupSetApi
     */
    adminMockupSetsMockupSetIdGet(requestParameters, options) {
        return AdminMockupSetApiFp(this.configuration).adminMockupSetsMockupSetIdGet(requestParameters.mockupSetId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [Admin] create a mockup set
     * @param {AdminMockupSetApiAdminMockupSetsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminMockupSetApi
     */
    adminMockupSetsPost(requestParameters = {}, options) {
        return AdminMockupSetApiFp(this.configuration).adminMockupSetsPost(requestParameters.adminMockupSetsPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * AdminOrdersApi - axios parameter creator
 * @export
 */
export const AdminOrdersApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary [Admin] List orders, search by product name and customer name, filter by order status and order type
         * @param {string} [searchTerm]
         * @param {string} [orderStatuses] A comma separated list of order status string
         * @param {SalesChannel} [salesChannel]
         * @param {string} [shippingOfficeId]
         * @param {string} [platformId]
         * @param {boolean} [existsInOdoo]
         * @param {number} [pageSize]
         * @param {number} [offset]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersGet: (searchTerm, orderStatuses, salesChannel, shippingOfficeId, platformId, existsInOdoo, pageSize, offset, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/admin/orders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            if (searchTerm !== undefined) {
                localVarQueryParameter['searchTerm'] = searchTerm;
            }
            if (orderStatuses !== undefined) {
                localVarQueryParameter['orderStatuses'] = orderStatuses;
            }
            if (salesChannel !== undefined) {
                localVarQueryParameter['salesChannel'] = salesChannel;
            }
            if (shippingOfficeId !== undefined) {
                localVarQueryParameter['shippingOfficeId'] = shippingOfficeId;
            }
            if (platformId !== undefined) {
                localVarQueryParameter['platformId'] = platformId;
            }
            if (existsInOdoo !== undefined) {
                localVarQueryParameter['existsInOdoo'] = existsInOdoo;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary change the selected feature options for a framing order.
         * @param {string} orderId
         * @param {string} configurationId
         * @param {Array<FeatureOptionReplacementDto>} [featureOptionReplacementDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersOrderIdConfigurationsConfigurationIdFeatureoptionsPatch: (orderId, configurationId, featureOptionReplacementDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('adminOrdersOrderIdConfigurationsConfigurationIdFeatureoptionsPatch', 'orderId', orderId);
            // verify required parameter 'configurationId' is not null or undefined
            assertParamExists('adminOrdersOrderIdConfigurationsConfigurationIdFeatureoptionsPatch', 'configurationId', configurationId);
            const localVarPath = `/admin/orders/{orderId}/configurations/{configurationId}/featureoptions`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)))
                .replace(`{${"configurationId"}}`, encodeURIComponent(String(configurationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(featureOptionReplacementDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} configurationId
         * @param {string} orderId
         * @param {AdminConfigurationsConfigurationIdFrameConfigurationPatchRequest} [adminConfigurationsConfigurationIdFrameConfigurationPatchRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersOrderIdConfigurationsConfigurationIdFrameConfigurationPatch: (configurationId, orderId, adminConfigurationsConfigurationIdFrameConfigurationPatchRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'configurationId' is not null or undefined
            assertParamExists('adminOrdersOrderIdConfigurationsConfigurationIdFrameConfigurationPatch', 'configurationId', configurationId);
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('adminOrdersOrderIdConfigurationsConfigurationIdFrameConfigurationPatch', 'orderId', orderId);
            const localVarPath = `/admin/orders/{orderId}/configurations/{configurationId}/frame-configuration`
                .replace(`{${"configurationId"}}`, encodeURIComponent(String(configurationId)))
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(adminConfigurationsConfigurationIdFrameConfigurationPatchRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary (Admin) Add a file to an order
         * @param {string} orderId
         * @param {string} [name]
         * @param {File} [file]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersOrderIdFilesPost: (orderId, name, file, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('adminOrdersOrderIdFilesPost', 'orderId', orderId);
            const localVarPath = `/admin/orders/{orderId}/files`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
            // authentication oidc required
            if (name !== undefined) {
                localVarFormParams.append('Name', name);
            }
            if (file !== undefined) {
                localVarFormParams.append('File', file);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = localVarFormParams;
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary (Admin) fetches a FrameTheGame order by its id
         * @param {string} orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersOrderIdGet: (orderId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('adminOrdersOrderIdGet', 'orderId', orderId);
            const localVarPath = `/admin/orders/{orderId}`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [Admin] Update the notes of an order
         * @param {string} orderId
         * @param {AdminConfigurationsConfigurationIdNotesPatchRequest} [adminConfigurationsConfigurationIdNotesPatchRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersOrderIdNotesPatch: (orderId, adminConfigurationsConfigurationIdNotesPatchRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('adminOrdersOrderIdNotesPatch', 'orderId', orderId);
            const localVarPath = `/admin/orders/{orderId}/notes`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(adminConfigurationsConfigurationIdNotesPatchRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} orderId
         * @param {OrderStatus} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersOrderIdOrderStatusPatch: (orderId, body, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('adminOrdersOrderIdOrderStatusPatch', 'orderId', orderId);
            const localVarPath = `/admin/orders/{orderId}/order-status`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary (Admin) Update partial delivery allowed status
         * @param {string} orderId
         * @param {boolean} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersOrderIdPartialDeliveryPatch: (orderId, body, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('adminOrdersOrderIdPartialDeliveryPatch', 'orderId', orderId);
            const localVarPath = `/admin/orders/{orderId}/partial-delivery`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [Admin] Download a pdf containing the order details
         * @param {string} orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersOrderIdPdfGet: (orderId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('adminOrdersOrderIdPdfGet', 'orderId', orderId);
            const localVarPath = `/admin/orders/{orderId}/pdf`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary (Migration) Set order names for framing orders
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersSetOrderNamesPatch: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/admin/orders/set-order-names`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary (Migration) Set order numbers for framing orders
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersSetOrderNumbersPatch: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/admin/orders/set-order-numbers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * AdminOrdersApi - functional programming interface
 * @export
 */
export const AdminOrdersApiFp = function (configuration) {
    const localVarAxiosParamCreator = AdminOrdersApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary [Admin] List orders, search by product name and customer name, filter by order status and order type
         * @param {string} [searchTerm]
         * @param {string} [orderStatuses] A comma separated list of order status string
         * @param {SalesChannel} [salesChannel]
         * @param {string} [shippingOfficeId]
         * @param {string} [platformId]
         * @param {boolean} [existsInOdoo]
         * @param {number} [pageSize]
         * @param {number} [offset]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersGet(searchTerm, orderStatuses, salesChannel, shippingOfficeId, platformId, existsInOdoo, pageSize, offset, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminOrdersGet(searchTerm, orderStatuses, salesChannel, shippingOfficeId, platformId, existsInOdoo, pageSize, offset, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary change the selected feature options for a framing order.
         * @param {string} orderId
         * @param {string} configurationId
         * @param {Array<FeatureOptionReplacementDto>} [featureOptionReplacementDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersOrderIdConfigurationsConfigurationIdFeatureoptionsPatch(orderId, configurationId, featureOptionReplacementDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminOrdersOrderIdConfigurationsConfigurationIdFeatureoptionsPatch(orderId, configurationId, featureOptionReplacementDto, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} configurationId
         * @param {string} orderId
         * @param {AdminConfigurationsConfigurationIdFrameConfigurationPatchRequest} [adminConfigurationsConfigurationIdFrameConfigurationPatchRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersOrderIdConfigurationsConfigurationIdFrameConfigurationPatch(configurationId, orderId, adminConfigurationsConfigurationIdFrameConfigurationPatchRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminOrdersOrderIdConfigurationsConfigurationIdFrameConfigurationPatch(configurationId, orderId, adminConfigurationsConfigurationIdFrameConfigurationPatchRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary (Admin) Add a file to an order
         * @param {string} orderId
         * @param {string} [name]
         * @param {File} [file]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersOrderIdFilesPost(orderId, name, file, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminOrdersOrderIdFilesPost(orderId, name, file, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary (Admin) fetches a FrameTheGame order by its id
         * @param {string} orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersOrderIdGet(orderId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminOrdersOrderIdGet(orderId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [Admin] Update the notes of an order
         * @param {string} orderId
         * @param {AdminConfigurationsConfigurationIdNotesPatchRequest} [adminConfigurationsConfigurationIdNotesPatchRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersOrderIdNotesPatch(orderId, adminConfigurationsConfigurationIdNotesPatchRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminOrdersOrderIdNotesPatch(orderId, adminConfigurationsConfigurationIdNotesPatchRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} orderId
         * @param {OrderStatus} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersOrderIdOrderStatusPatch(orderId, body, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminOrdersOrderIdOrderStatusPatch(orderId, body, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary (Admin) Update partial delivery allowed status
         * @param {string} orderId
         * @param {boolean} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersOrderIdPartialDeliveryPatch(orderId, body, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminOrdersOrderIdPartialDeliveryPatch(orderId, body, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [Admin] Download a pdf containing the order details
         * @param {string} orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersOrderIdPdfGet(orderId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminOrdersOrderIdPdfGet(orderId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary (Migration) Set order names for framing orders
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersSetOrderNamesPatch(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminOrdersSetOrderNamesPatch(options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary (Migration) Set order numbers for framing orders
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersSetOrderNumbersPatch(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminOrdersSetOrderNumbersPatch(options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * AdminOrdersApi - factory interface
 * @export
 */
export const AdminOrdersApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AdminOrdersApiFp(configuration);
    return {
        /**
         *
         * @summary [Admin] List orders, search by product name and customer name, filter by order status and order type
         * @param {AdminOrdersApiAdminOrdersGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersGet(requestParameters = {}, options) {
            return localVarFp.adminOrdersGet(requestParameters.searchTerm, requestParameters.orderStatuses, requestParameters.salesChannel, requestParameters.shippingOfficeId, requestParameters.platformId, requestParameters.existsInOdoo, requestParameters.pageSize, requestParameters.offset, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary change the selected feature options for a framing order.
         * @param {AdminOrdersApiAdminOrdersOrderIdConfigurationsConfigurationIdFeatureoptionsPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersOrderIdConfigurationsConfigurationIdFeatureoptionsPatch(requestParameters, options) {
            return localVarFp.adminOrdersOrderIdConfigurationsConfigurationIdFeatureoptionsPatch(requestParameters.orderId, requestParameters.configurationId, requestParameters.featureOptionReplacementDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {AdminOrdersApiAdminOrdersOrderIdConfigurationsConfigurationIdFrameConfigurationPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersOrderIdConfigurationsConfigurationIdFrameConfigurationPatch(requestParameters, options) {
            return localVarFp.adminOrdersOrderIdConfigurationsConfigurationIdFrameConfigurationPatch(requestParameters.configurationId, requestParameters.orderId, requestParameters.adminConfigurationsConfigurationIdFrameConfigurationPatchRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary (Admin) Add a file to an order
         * @param {AdminOrdersApiAdminOrdersOrderIdFilesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersOrderIdFilesPost(requestParameters, options) {
            return localVarFp.adminOrdersOrderIdFilesPost(requestParameters.orderId, requestParameters.name, requestParameters.file, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary (Admin) fetches a FrameTheGame order by its id
         * @param {AdminOrdersApiAdminOrdersOrderIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersOrderIdGet(requestParameters, options) {
            return localVarFp.adminOrdersOrderIdGet(requestParameters.orderId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [Admin] Update the notes of an order
         * @param {AdminOrdersApiAdminOrdersOrderIdNotesPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersOrderIdNotesPatch(requestParameters, options) {
            return localVarFp.adminOrdersOrderIdNotesPatch(requestParameters.orderId, requestParameters.adminConfigurationsConfigurationIdNotesPatchRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {AdminOrdersApiAdminOrdersOrderIdOrderStatusPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersOrderIdOrderStatusPatch(requestParameters, options) {
            return localVarFp.adminOrdersOrderIdOrderStatusPatch(requestParameters.orderId, requestParameters.body, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary (Admin) Update partial delivery allowed status
         * @param {AdminOrdersApiAdminOrdersOrderIdPartialDeliveryPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersOrderIdPartialDeliveryPatch(requestParameters, options) {
            return localVarFp.adminOrdersOrderIdPartialDeliveryPatch(requestParameters.orderId, requestParameters.body, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [Admin] Download a pdf containing the order details
         * @param {AdminOrdersApiAdminOrdersOrderIdPdfGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersOrderIdPdfGet(requestParameters, options) {
            return localVarFp.adminOrdersOrderIdPdfGet(requestParameters.orderId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary (Migration) Set order names for framing orders
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersSetOrderNamesPatch(options) {
            return localVarFp.adminOrdersSetOrderNamesPatch(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary (Migration) Set order numbers for framing orders
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersSetOrderNumbersPatch(options) {
            return localVarFp.adminOrdersSetOrderNumbersPatch(options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AdminOrdersApi - object-oriented interface
 * @export
 * @class AdminOrdersApi
 * @extends {BaseAPI}
 */
export class AdminOrdersApi extends BaseAPI {
    /**
     *
     * @summary [Admin] List orders, search by product name and customer name, filter by order status and order type
     * @param {AdminOrdersApiAdminOrdersGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrdersApi
     */
    adminOrdersGet(requestParameters = {}, options) {
        return AdminOrdersApiFp(this.configuration).adminOrdersGet(requestParameters.searchTerm, requestParameters.orderStatuses, requestParameters.salesChannel, requestParameters.shippingOfficeId, requestParameters.platformId, requestParameters.existsInOdoo, requestParameters.pageSize, requestParameters.offset, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary change the selected feature options for a framing order.
     * @param {AdminOrdersApiAdminOrdersOrderIdConfigurationsConfigurationIdFeatureoptionsPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrdersApi
     */
    adminOrdersOrderIdConfigurationsConfigurationIdFeatureoptionsPatch(requestParameters, options) {
        return AdminOrdersApiFp(this.configuration).adminOrdersOrderIdConfigurationsConfigurationIdFeatureoptionsPatch(requestParameters.orderId, requestParameters.configurationId, requestParameters.featureOptionReplacementDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AdminOrdersApiAdminOrdersOrderIdConfigurationsConfigurationIdFrameConfigurationPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrdersApi
     */
    adminOrdersOrderIdConfigurationsConfigurationIdFrameConfigurationPatch(requestParameters, options) {
        return AdminOrdersApiFp(this.configuration).adminOrdersOrderIdConfigurationsConfigurationIdFrameConfigurationPatch(requestParameters.configurationId, requestParameters.orderId, requestParameters.adminConfigurationsConfigurationIdFrameConfigurationPatchRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary (Admin) Add a file to an order
     * @param {AdminOrdersApiAdminOrdersOrderIdFilesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrdersApi
     */
    adminOrdersOrderIdFilesPost(requestParameters, options) {
        return AdminOrdersApiFp(this.configuration).adminOrdersOrderIdFilesPost(requestParameters.orderId, requestParameters.name, requestParameters.file, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary (Admin) fetches a FrameTheGame order by its id
     * @param {AdminOrdersApiAdminOrdersOrderIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrdersApi
     */
    adminOrdersOrderIdGet(requestParameters, options) {
        return AdminOrdersApiFp(this.configuration).adminOrdersOrderIdGet(requestParameters.orderId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [Admin] Update the notes of an order
     * @param {AdminOrdersApiAdminOrdersOrderIdNotesPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrdersApi
     */
    adminOrdersOrderIdNotesPatch(requestParameters, options) {
        return AdminOrdersApiFp(this.configuration).adminOrdersOrderIdNotesPatch(requestParameters.orderId, requestParameters.adminConfigurationsConfigurationIdNotesPatchRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AdminOrdersApiAdminOrdersOrderIdOrderStatusPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrdersApi
     */
    adminOrdersOrderIdOrderStatusPatch(requestParameters, options) {
        return AdminOrdersApiFp(this.configuration).adminOrdersOrderIdOrderStatusPatch(requestParameters.orderId, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary (Admin) Update partial delivery allowed status
     * @param {AdminOrdersApiAdminOrdersOrderIdPartialDeliveryPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrdersApi
     */
    adminOrdersOrderIdPartialDeliveryPatch(requestParameters, options) {
        return AdminOrdersApiFp(this.configuration).adminOrdersOrderIdPartialDeliveryPatch(requestParameters.orderId, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [Admin] Download a pdf containing the order details
     * @param {AdminOrdersApiAdminOrdersOrderIdPdfGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrdersApi
     */
    adminOrdersOrderIdPdfGet(requestParameters, options) {
        return AdminOrdersApiFp(this.configuration).adminOrdersOrderIdPdfGet(requestParameters.orderId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary (Migration) Set order names for framing orders
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrdersApi
     */
    adminOrdersSetOrderNamesPatch(options) {
        return AdminOrdersApiFp(this.configuration).adminOrdersSetOrderNamesPatch(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary (Migration) Set order numbers for framing orders
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrdersApi
     */
    adminOrdersSetOrderNumbersPatch(options) {
        return AdminOrdersApiFp(this.configuration).adminOrdersSetOrderNumbersPatch(options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * AdminPassepartoutImageApi - axios parameter creator
 * @export
 */
export const AdminPassepartoutImageApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary [Admin] change order (sort score) of passepartout images
         * @param {string} [passepartoutIdsOrder] A list of order passepartout ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPassepartoutImagesChangeOrderPut: (passepartoutIdsOrder, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/admin/passepartout-images/change-order`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            if (passepartoutIdsOrder !== undefined) {
                localVarQueryParameter['passepartoutIdsOrder'] = passepartoutIdsOrder;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [Admin] enable/disable a passepartout image
         * @param {string} id The id of the passepartout image
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPassepartoutImagesIdTogglePatch: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminPassepartoutImagesIdTogglePatch', 'id', id);
            const localVarPath = `/admin/passepartout-images/{id}/toggle`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [Admin] Soft delete passepartout image by id
         * @param {string} passepartoutId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPassepartoutImagesPassepartoutIdDelete: (passepartoutId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'passepartoutId' is not null or undefined
            assertParamExists('adminPassepartoutImagesPassepartoutIdDelete', 'passepartoutId', passepartoutId);
            const localVarPath = `/admin/passepartout-images/{passepartoutId}`
                .replace(`{${"passepartoutId"}}`, encodeURIComponent(String(passepartoutId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [Admin] Get passepartout image by id
         * @param {string} passepartoutId
         * @param {boolean} [includeDeleted]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPassepartoutImagesPassepartoutIdGet: (passepartoutId, includeDeleted, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'passepartoutId' is not null or undefined
            assertParamExists('adminPassepartoutImagesPassepartoutIdGet', 'passepartoutId', passepartoutId);
            const localVarPath = `/admin/passepartout-images/{passepartoutId}`
                .replace(`{${"passepartoutId"}}`, encodeURIComponent(String(passepartoutId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            if (includeDeleted !== undefined) {
                localVarQueryParameter['includeDeleted'] = includeDeleted;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * AdminPassepartoutImageApi - functional programming interface
 * @export
 */
export const AdminPassepartoutImageApiFp = function (configuration) {
    const localVarAxiosParamCreator = AdminPassepartoutImageApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary [Admin] change order (sort score) of passepartout images
         * @param {string} [passepartoutIdsOrder] A list of order passepartout ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPassepartoutImagesChangeOrderPut(passepartoutIdsOrder, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminPassepartoutImagesChangeOrderPut(passepartoutIdsOrder, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [Admin] enable/disable a passepartout image
         * @param {string} id The id of the passepartout image
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPassepartoutImagesIdTogglePatch(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminPassepartoutImagesIdTogglePatch(id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [Admin] Soft delete passepartout image by id
         * @param {string} passepartoutId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPassepartoutImagesPassepartoutIdDelete(passepartoutId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminPassepartoutImagesPassepartoutIdDelete(passepartoutId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [Admin] Get passepartout image by id
         * @param {string} passepartoutId
         * @param {boolean} [includeDeleted]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPassepartoutImagesPassepartoutIdGet(passepartoutId, includeDeleted, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminPassepartoutImagesPassepartoutIdGet(passepartoutId, includeDeleted, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * AdminPassepartoutImageApi - factory interface
 * @export
 */
export const AdminPassepartoutImageApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AdminPassepartoutImageApiFp(configuration);
    return {
        /**
         *
         * @summary [Admin] change order (sort score) of passepartout images
         * @param {AdminPassepartoutImageApiAdminPassepartoutImagesChangeOrderPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPassepartoutImagesChangeOrderPut(requestParameters = {}, options) {
            return localVarFp.adminPassepartoutImagesChangeOrderPut(requestParameters.passepartoutIdsOrder, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [Admin] enable/disable a passepartout image
         * @param {AdminPassepartoutImageApiAdminPassepartoutImagesIdTogglePatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPassepartoutImagesIdTogglePatch(requestParameters, options) {
            return localVarFp.adminPassepartoutImagesIdTogglePatch(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [Admin] Soft delete passepartout image by id
         * @param {AdminPassepartoutImageApiAdminPassepartoutImagesPassepartoutIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPassepartoutImagesPassepartoutIdDelete(requestParameters, options) {
            return localVarFp.adminPassepartoutImagesPassepartoutIdDelete(requestParameters.passepartoutId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [Admin] Get passepartout image by id
         * @param {AdminPassepartoutImageApiAdminPassepartoutImagesPassepartoutIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPassepartoutImagesPassepartoutIdGet(requestParameters, options) {
            return localVarFp.adminPassepartoutImagesPassepartoutIdGet(requestParameters.passepartoutId, requestParameters.includeDeleted, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AdminPassepartoutImageApi - object-oriented interface
 * @export
 * @class AdminPassepartoutImageApi
 * @extends {BaseAPI}
 */
export class AdminPassepartoutImageApi extends BaseAPI {
    /**
     *
     * @summary [Admin] change order (sort score) of passepartout images
     * @param {AdminPassepartoutImageApiAdminPassepartoutImagesChangeOrderPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminPassepartoutImageApi
     */
    adminPassepartoutImagesChangeOrderPut(requestParameters = {}, options) {
        return AdminPassepartoutImageApiFp(this.configuration).adminPassepartoutImagesChangeOrderPut(requestParameters.passepartoutIdsOrder, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [Admin] enable/disable a passepartout image
     * @param {AdminPassepartoutImageApiAdminPassepartoutImagesIdTogglePatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminPassepartoutImageApi
     */
    adminPassepartoutImagesIdTogglePatch(requestParameters, options) {
        return AdminPassepartoutImageApiFp(this.configuration).adminPassepartoutImagesIdTogglePatch(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [Admin] Soft delete passepartout image by id
     * @param {AdminPassepartoutImageApiAdminPassepartoutImagesPassepartoutIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminPassepartoutImageApi
     */
    adminPassepartoutImagesPassepartoutIdDelete(requestParameters, options) {
        return AdminPassepartoutImageApiFp(this.configuration).adminPassepartoutImagesPassepartoutIdDelete(requestParameters.passepartoutId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [Admin] Get passepartout image by id
     * @param {AdminPassepartoutImageApiAdminPassepartoutImagesPassepartoutIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminPassepartoutImageApi
     */
    adminPassepartoutImagesPassepartoutIdGet(requestParameters, options) {
        return AdminPassepartoutImageApiFp(this.configuration).adminPassepartoutImagesPassepartoutIdGet(requestParameters.passepartoutId, requestParameters.includeDeleted, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * AdminShippingOfficesApi - axios parameter creator
 * @export
 */
export const AdminShippingOfficesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} [offset]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminShippingOfficesGet: (offset, pageSize, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/admin/shipping-offices`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * AdminShippingOfficesApi - functional programming interface
 * @export
 */
export const AdminShippingOfficesApiFp = function (configuration) {
    const localVarAxiosParamCreator = AdminShippingOfficesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {number} [offset]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminShippingOfficesGet(offset, pageSize, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminShippingOfficesGet(offset, pageSize, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * AdminShippingOfficesApi - factory interface
 * @export
 */
export const AdminShippingOfficesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AdminShippingOfficesApiFp(configuration);
    return {
        /**
         *
         * @param {AdminShippingOfficesApiAdminShippingOfficesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminShippingOfficesGet(requestParameters = {}, options) {
            return localVarFp.adminShippingOfficesGet(requestParameters.offset, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AdminShippingOfficesApi - object-oriented interface
 * @export
 * @class AdminShippingOfficesApi
 * @extends {BaseAPI}
 */
export class AdminShippingOfficesApi extends BaseAPI {
    /**
     *
     * @param {AdminShippingOfficesApiAdminShippingOfficesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminShippingOfficesApi
     */
    adminShippingOfficesGet(requestParameters = {}, options) {
        return AdminShippingOfficesApiFp(this.configuration).adminShippingOfficesGet(requestParameters.offset, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * AdminTeamApi - axios parameter creator
 * @export
 */
export const AdminTeamApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary [Admin] list teams, search by name
         * @param {string} [searchTerm]
         * @param {number} [pageSize]
         * @param {number} [offset]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminTeamsGet: (searchTerm, pageSize, offset, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/admin/teams`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            if (searchTerm !== undefined) {
                localVarQueryParameter['searchTerm'] = searchTerm;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [Admin] Moves signed s3 temp urls to permanent location and saves them in a passe-partout image
         * @param {AdminFrameableProductsPassePartoutPatchRequest} [adminFrameableProductsPassePartoutPatchRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminTeamsPassepartoutImagesSavePost: (adminFrameableProductsPassePartoutPatchRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/admin/teams/passepartout-images/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(adminFrameableProductsPassePartoutPatchRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [Admin] create a new team
         * @param {AdminTeamsPostRequest} [adminTeamsPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminTeamsPost: (adminTeamsPostRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/admin/teams`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(adminTeamsPostRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [Admin] Get teams by Id
         * @param {string} teamId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminTeamsTeamIdGet: (teamId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('adminTeamsTeamIdGet', 'teamId', teamId);
            const localVarPath = `/admin/teams/{teamId}`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * AdminTeamApi - functional programming interface
 * @export
 */
export const AdminTeamApiFp = function (configuration) {
    const localVarAxiosParamCreator = AdminTeamApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary [Admin] list teams, search by name
         * @param {string} [searchTerm]
         * @param {number} [pageSize]
         * @param {number} [offset]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminTeamsGet(searchTerm, pageSize, offset, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminTeamsGet(searchTerm, pageSize, offset, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [Admin] Moves signed s3 temp urls to permanent location and saves them in a passe-partout image
         * @param {AdminFrameableProductsPassePartoutPatchRequest} [adminFrameableProductsPassePartoutPatchRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminTeamsPassepartoutImagesSavePost(adminFrameableProductsPassePartoutPatchRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminTeamsPassepartoutImagesSavePost(adminFrameableProductsPassePartoutPatchRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [Admin] create a new team
         * @param {AdminTeamsPostRequest} [adminTeamsPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminTeamsPost(adminTeamsPostRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminTeamsPost(adminTeamsPostRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [Admin] Get teams by Id
         * @param {string} teamId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminTeamsTeamIdGet(teamId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminTeamsTeamIdGet(teamId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * AdminTeamApi - factory interface
 * @export
 */
export const AdminTeamApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AdminTeamApiFp(configuration);
    return {
        /**
         *
         * @summary [Admin] list teams, search by name
         * @param {AdminTeamApiAdminTeamsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminTeamsGet(requestParameters = {}, options) {
            return localVarFp.adminTeamsGet(requestParameters.searchTerm, requestParameters.pageSize, requestParameters.offset, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [Admin] Moves signed s3 temp urls to permanent location and saves them in a passe-partout image
         * @param {AdminTeamApiAdminTeamsPassepartoutImagesSavePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminTeamsPassepartoutImagesSavePost(requestParameters = {}, options) {
            return localVarFp.adminTeamsPassepartoutImagesSavePost(requestParameters.adminFrameableProductsPassePartoutPatchRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [Admin] create a new team
         * @param {AdminTeamApiAdminTeamsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminTeamsPost(requestParameters = {}, options) {
            return localVarFp.adminTeamsPost(requestParameters.adminTeamsPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [Admin] Get teams by Id
         * @param {AdminTeamApiAdminTeamsTeamIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminTeamsTeamIdGet(requestParameters, options) {
            return localVarFp.adminTeamsTeamIdGet(requestParameters.teamId, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AdminTeamApi - object-oriented interface
 * @export
 * @class AdminTeamApi
 * @extends {BaseAPI}
 */
export class AdminTeamApi extends BaseAPI {
    /**
     *
     * @summary [Admin] list teams, search by name
     * @param {AdminTeamApiAdminTeamsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminTeamApi
     */
    adminTeamsGet(requestParameters = {}, options) {
        return AdminTeamApiFp(this.configuration).adminTeamsGet(requestParameters.searchTerm, requestParameters.pageSize, requestParameters.offset, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [Admin] Moves signed s3 temp urls to permanent location and saves them in a passe-partout image
     * @param {AdminTeamApiAdminTeamsPassepartoutImagesSavePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminTeamApi
     */
    adminTeamsPassepartoutImagesSavePost(requestParameters = {}, options) {
        return AdminTeamApiFp(this.configuration).adminTeamsPassepartoutImagesSavePost(requestParameters.adminFrameableProductsPassePartoutPatchRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [Admin] create a new team
     * @param {AdminTeamApiAdminTeamsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminTeamApi
     */
    adminTeamsPost(requestParameters = {}, options) {
        return AdminTeamApiFp(this.configuration).adminTeamsPost(requestParameters.adminTeamsPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [Admin] Get teams by Id
     * @param {AdminTeamApiAdminTeamsTeamIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminTeamApi
     */
    adminTeamsTeamIdGet(requestParameters, options) {
        return AdminTeamApiFp(this.configuration).adminTeamsTeamIdGet(requestParameters.teamId, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * CartApi - axios parameter creator
 * @export
 */
export const CartApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Attempts to find the most recently created cart for the external id and specified user. If no cart  is found, a new one is created and returned.
         * @summary Get the most recently created cart or create a new one if no carts are found
         * @param {string} externalId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cartsExternalExternalIdLatestPost: (externalId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'externalId' is not null or undefined
            assertParamExists('cartsExternalExternalIdLatestPost', 'externalId', externalId);
            const localVarPath = `/carts/external/{externalId}/latest`
                .replace(`{${"externalId"}}`, encodeURIComponent(String(externalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * CartApi - functional programming interface
 * @export
 */
export const CartApiFp = function (configuration) {
    const localVarAxiosParamCreator = CartApiAxiosParamCreator(configuration);
    return {
        /**
         * Attempts to find the most recently created cart for the external id and specified user. If no cart  is found, a new one is created and returned.
         * @summary Get the most recently created cart or create a new one if no carts are found
         * @param {string} externalId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cartsExternalExternalIdLatestPost(externalId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.cartsExternalExternalIdLatestPost(externalId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * CartApi - factory interface
 * @export
 */
export const CartApiFactory = function (configuration, basePath, axios) {
    const localVarFp = CartApiFp(configuration);
    return {
        /**
         * Attempts to find the most recently created cart for the external id and specified user. If no cart  is found, a new one is created and returned.
         * @summary Get the most recently created cart or create a new one if no carts are found
         * @param {CartApiCartsExternalExternalIdLatestPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cartsExternalExternalIdLatestPost(requestParameters, options) {
            return localVarFp.cartsExternalExternalIdLatestPost(requestParameters.externalId, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * CartApi - object-oriented interface
 * @export
 * @class CartApi
 * @extends {BaseAPI}
 */
export class CartApi extends BaseAPI {
    /**
     * Attempts to find the most recently created cart for the external id and specified user. If no cart  is found, a new one is created and returned.
     * @summary Get the most recently created cart or create a new one if no carts are found
     * @param {CartApiCartsExternalExternalIdLatestPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CartApi
     */
    cartsExternalExternalIdLatestPost(requestParameters, options) {
        return CartApiFp(this.configuration).cartsExternalExternalIdLatestPost(requestParameters.externalId, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * ConfigurationApi - axios parameter creator
 * @export
 */
export const ConfigurationApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Get a configuration by cart id.  This is intended to be a temporary endpoint as an intermediate step towards retiring carts.  For now it is necessary to fetch the FrameableProduct from a separate endpoint.
         * @param {string} cartId
         * @param {string} [currency] The currency to use for the total price calculation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configurationsCartsCartIdGet: (cartId, currency, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'cartId' is not null or undefined
            assertParamExists('configurationsCartsCartIdGet', 'cartId', cartId);
            const localVarPath = `/configurations/carts/{cartId}`
                .replace(`{${"cartId"}}`, encodeURIComponent(String(cartId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (currency !== undefined) {
                localVarQueryParameter['currency'] = currency;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Finalize a B2C frame configuration
         * @param {string} configurationId
         * @param {ConfigurationsConfigurationIdCheckoutPostRequest} [configurationsConfigurationIdCheckoutPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configurationsConfigurationIdCheckoutPost: (configurationId, configurationsConfigurationIdCheckoutPostRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'configurationId' is not null or undefined
            assertParamExists('configurationsConfigurationIdCheckoutPost', 'configurationId', configurationId);
            const localVarPath = `/configurations/{configurationId}/checkout`
                .replace(`{${"configurationId"}}`, encodeURIComponent(String(configurationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(configurationsConfigurationIdCheckoutPostRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Update frame configuration from the configurator
         * @param {string} configurationId
         * @param {ConfigurationsConfigurationIdFrameConfigurationPutRequest} [configurationsConfigurationIdFrameConfigurationPutRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configurationsConfigurationIdFrameConfigurationPut: (configurationId, configurationsConfigurationIdFrameConfigurationPutRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'configurationId' is not null or undefined
            assertParamExists('configurationsConfigurationIdFrameConfigurationPut', 'configurationId', configurationId);
            const localVarPath = `/configurations/{configurationId}/frame-configuration`
                .replace(`{${"configurationId"}}`, encodeURIComponent(String(configurationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(configurationsConfigurationIdFrameConfigurationPutRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get frameable product by configuration id.
         * @param {string} configurationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configurationsConfigurationIdFrameableProductGet: (configurationId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'configurationId' is not null or undefined
            assertParamExists('configurationsConfigurationIdFrameableProductGet', 'configurationId', configurationId);
            const localVarPath = `/configurations/{configurationId}/frameable-product`
                .replace(`{${"configurationId"}}`, encodeURIComponent(String(configurationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * a 404 from this endpoint can be considered a valid response. Not all Configurations have a Frame Configuration  We tried to do a 204 for when there is no Frame Configuration, but it did not generate correctly in the SDK
         * @param {string} configurationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configurationsConfigurationIdGet: (configurationId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'configurationId' is not null or undefined
            assertParamExists('configurationsConfigurationIdGet', 'configurationId', configurationId);
            const localVarPath = `/configurations/{configurationId}`
                .replace(`{${"configurationId"}}`, encodeURIComponent(String(configurationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *  Attempts to set the configuration\'s status to Confirmed. This signifies that the user has finished              configuring and configuration has been agreed on, by both parties.   NOTE: Currently this endpoint is accessible anonymously because we don\'t have an authentication solution              for the configurator at the time of implementation. As soon as we have a good model for authenticating users in the              configurator, we can make this an admin-only endpoint again.
         * @summary Attempts to set the configuration\'s status to Confirmed
         * @param {string} configurationId
         * @param {File} [frameImage]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configurationsConfigurationIdStatusConfirmedPost: (configurationId, frameImage, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'configurationId' is not null or undefined
            assertParamExists('configurationsConfigurationIdStatusConfirmedPost', 'configurationId', configurationId);
            const localVarPath = `/configurations/{configurationId}/status/confirmed`
                .replace(`{${"configurationId"}}`, encodeURIComponent(String(configurationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
            // authentication Bearer required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (frameImage !== undefined) {
                localVarFormParams.append('FrameImage', frameImage);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = localVarFormParams;
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Create a new configuration for a user
         * @param {ConfigurationsPostRequest} [configurationsPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configurationsPost: (configurationsPostRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/configurations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(configurationsPostRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [internal] Gets a configuration by external id and user id, and if it doesn\'t exist creates it.
         * @param {string} externalId
         * @param {string} [cartId]
         * @param {string} [framePreviewId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalConfigurationsFromExternalIdPost: (externalId, cartId, framePreviewId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'externalId' is not null or undefined
            assertParamExists('internalConfigurationsFromExternalIdPost', 'externalId', externalId);
            const localVarPath = `/internal/configurations/from/{externalId}`
                .replace(`{${"externalId"}}`, encodeURIComponent(String(externalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (cartId !== undefined) {
                localVarQueryParameter['cartId'] = cartId;
            }
            if (framePreviewId !== undefined) {
                localVarQueryParameter['framePreviewId'] = framePreviewId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * ConfigurationApi - functional programming interface
 * @export
 */
export const ConfigurationApiFp = function (configuration) {
    const localVarAxiosParamCreator = ConfigurationApiAxiosParamCreator(configuration);
    return {
        /**
         * Get a configuration by cart id.  This is intended to be a temporary endpoint as an intermediate step towards retiring carts.  For now it is necessary to fetch the FrameableProduct from a separate endpoint.
         * @param {string} cartId
         * @param {string} [currency] The currency to use for the total price calculation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configurationsCartsCartIdGet(cartId, currency, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.configurationsCartsCartIdGet(cartId, currency, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Finalize a B2C frame configuration
         * @param {string} configurationId
         * @param {ConfigurationsConfigurationIdCheckoutPostRequest} [configurationsConfigurationIdCheckoutPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configurationsConfigurationIdCheckoutPost(configurationId, configurationsConfigurationIdCheckoutPostRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.configurationsConfigurationIdCheckoutPost(configurationId, configurationsConfigurationIdCheckoutPostRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Update frame configuration from the configurator
         * @param {string} configurationId
         * @param {ConfigurationsConfigurationIdFrameConfigurationPutRequest} [configurationsConfigurationIdFrameConfigurationPutRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configurationsConfigurationIdFrameConfigurationPut(configurationId, configurationsConfigurationIdFrameConfigurationPutRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.configurationsConfigurationIdFrameConfigurationPut(configurationId, configurationsConfigurationIdFrameConfigurationPutRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get frameable product by configuration id.
         * @param {string} configurationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configurationsConfigurationIdFrameableProductGet(configurationId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.configurationsConfigurationIdFrameableProductGet(configurationId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * a 404 from this endpoint can be considered a valid response. Not all Configurations have a Frame Configuration  We tried to do a 204 for when there is no Frame Configuration, but it did not generate correctly in the SDK
         * @param {string} configurationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configurationsConfigurationIdGet(configurationId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.configurationsConfigurationIdGet(configurationId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *  Attempts to set the configuration\'s status to Confirmed. This signifies that the user has finished              configuring and configuration has been agreed on, by both parties.   NOTE: Currently this endpoint is accessible anonymously because we don\'t have an authentication solution              for the configurator at the time of implementation. As soon as we have a good model for authenticating users in the              configurator, we can make this an admin-only endpoint again.
         * @summary Attempts to set the configuration\'s status to Confirmed
         * @param {string} configurationId
         * @param {File} [frameImage]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configurationsConfigurationIdStatusConfirmedPost(configurationId, frameImage, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.configurationsConfigurationIdStatusConfirmedPost(configurationId, frameImage, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Create a new configuration for a user
         * @param {ConfigurationsPostRequest} [configurationsPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configurationsPost(configurationsPostRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.configurationsPost(configurationsPostRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [internal] Gets a configuration by external id and user id, and if it doesn\'t exist creates it.
         * @param {string} externalId
         * @param {string} [cartId]
         * @param {string} [framePreviewId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalConfigurationsFromExternalIdPost(externalId, cartId, framePreviewId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.internalConfigurationsFromExternalIdPost(externalId, cartId, framePreviewId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * ConfigurationApi - factory interface
 * @export
 */
export const ConfigurationApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ConfigurationApiFp(configuration);
    return {
        /**
         * Get a configuration by cart id.  This is intended to be a temporary endpoint as an intermediate step towards retiring carts.  For now it is necessary to fetch the FrameableProduct from a separate endpoint.
         * @param {ConfigurationApiConfigurationsCartsCartIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configurationsCartsCartIdGet(requestParameters, options) {
            return localVarFp.configurationsCartsCartIdGet(requestParameters.cartId, requestParameters.currency, options).then((request) => request(axios, basePath));
        },
        /**
         * Finalize a B2C frame configuration
         * @param {ConfigurationApiConfigurationsConfigurationIdCheckoutPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configurationsConfigurationIdCheckoutPost(requestParameters, options) {
            return localVarFp.configurationsConfigurationIdCheckoutPost(requestParameters.configurationId, requestParameters.configurationsConfigurationIdCheckoutPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update frame configuration from the configurator
         * @param {ConfigurationApiConfigurationsConfigurationIdFrameConfigurationPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configurationsConfigurationIdFrameConfigurationPut(requestParameters, options) {
            return localVarFp.configurationsConfigurationIdFrameConfigurationPut(requestParameters.configurationId, requestParameters.configurationsConfigurationIdFrameConfigurationPutRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get frameable product by configuration id.
         * @param {ConfigurationApiConfigurationsConfigurationIdFrameableProductGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configurationsConfigurationIdFrameableProductGet(requestParameters, options) {
            return localVarFp.configurationsConfigurationIdFrameableProductGet(requestParameters.configurationId, options).then((request) => request(axios, basePath));
        },
        /**
         * a 404 from this endpoint can be considered a valid response. Not all Configurations have a Frame Configuration  We tried to do a 204 for when there is no Frame Configuration, but it did not generate correctly in the SDK
         * @param {ConfigurationApiConfigurationsConfigurationIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configurationsConfigurationIdGet(requestParameters, options) {
            return localVarFp.configurationsConfigurationIdGet(requestParameters.configurationId, options).then((request) => request(axios, basePath));
        },
        /**
         *  Attempts to set the configuration\'s status to Confirmed. This signifies that the user has finished              configuring and configuration has been agreed on, by both parties.   NOTE: Currently this endpoint is accessible anonymously because we don\'t have an authentication solution              for the configurator at the time of implementation. As soon as we have a good model for authenticating users in the              configurator, we can make this an admin-only endpoint again.
         * @summary Attempts to set the configuration\'s status to Confirmed
         * @param {ConfigurationApiConfigurationsConfigurationIdStatusConfirmedPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configurationsConfigurationIdStatusConfirmedPost(requestParameters, options) {
            return localVarFp.configurationsConfigurationIdStatusConfirmedPost(requestParameters.configurationId, requestParameters.frameImage, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new configuration for a user
         * @param {ConfigurationApiConfigurationsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configurationsPost(requestParameters = {}, options) {
            return localVarFp.configurationsPost(requestParameters.configurationsPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [internal] Gets a configuration by external id and user id, and if it doesn\'t exist creates it.
         * @param {ConfigurationApiInternalConfigurationsFromExternalIdPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalConfigurationsFromExternalIdPost(requestParameters, options) {
            return localVarFp.internalConfigurationsFromExternalIdPost(requestParameters.externalId, requestParameters.cartId, requestParameters.framePreviewId, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ConfigurationApi - object-oriented interface
 * @export
 * @class ConfigurationApi
 * @extends {BaseAPI}
 */
export class ConfigurationApi extends BaseAPI {
    /**
     * Get a configuration by cart id.  This is intended to be a temporary endpoint as an intermediate step towards retiring carts.  For now it is necessary to fetch the FrameableProduct from a separate endpoint.
     * @param {ConfigurationApiConfigurationsCartsCartIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigurationApi
     */
    configurationsCartsCartIdGet(requestParameters, options) {
        return ConfigurationApiFp(this.configuration).configurationsCartsCartIdGet(requestParameters.cartId, requestParameters.currency, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Finalize a B2C frame configuration
     * @param {ConfigurationApiConfigurationsConfigurationIdCheckoutPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigurationApi
     */
    configurationsConfigurationIdCheckoutPost(requestParameters, options) {
        return ConfigurationApiFp(this.configuration).configurationsConfigurationIdCheckoutPost(requestParameters.configurationId, requestParameters.configurationsConfigurationIdCheckoutPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Update frame configuration from the configurator
     * @param {ConfigurationApiConfigurationsConfigurationIdFrameConfigurationPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigurationApi
     */
    configurationsConfigurationIdFrameConfigurationPut(requestParameters, options) {
        return ConfigurationApiFp(this.configuration).configurationsConfigurationIdFrameConfigurationPut(requestParameters.configurationId, requestParameters.configurationsConfigurationIdFrameConfigurationPutRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get frameable product by configuration id.
     * @param {ConfigurationApiConfigurationsConfigurationIdFrameableProductGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigurationApi
     */
    configurationsConfigurationIdFrameableProductGet(requestParameters, options) {
        return ConfigurationApiFp(this.configuration).configurationsConfigurationIdFrameableProductGet(requestParameters.configurationId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * a 404 from this endpoint can be considered a valid response. Not all Configurations have a Frame Configuration  We tried to do a 204 for when there is no Frame Configuration, but it did not generate correctly in the SDK
     * @param {ConfigurationApiConfigurationsConfigurationIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigurationApi
     */
    configurationsConfigurationIdGet(requestParameters, options) {
        return ConfigurationApiFp(this.configuration).configurationsConfigurationIdGet(requestParameters.configurationId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *  Attempts to set the configuration\'s status to Confirmed. This signifies that the user has finished              configuring and configuration has been agreed on, by both parties.   NOTE: Currently this endpoint is accessible anonymously because we don\'t have an authentication solution              for the configurator at the time of implementation. As soon as we have a good model for authenticating users in the              configurator, we can make this an admin-only endpoint again.
     * @summary Attempts to set the configuration\'s status to Confirmed
     * @param {ConfigurationApiConfigurationsConfigurationIdStatusConfirmedPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigurationApi
     */
    configurationsConfigurationIdStatusConfirmedPost(requestParameters, options) {
        return ConfigurationApiFp(this.configuration).configurationsConfigurationIdStatusConfirmedPost(requestParameters.configurationId, requestParameters.frameImage, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Create a new configuration for a user
     * @param {ConfigurationApiConfigurationsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigurationApi
     */
    configurationsPost(requestParameters = {}, options) {
        return ConfigurationApiFp(this.configuration).configurationsPost(requestParameters.configurationsPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [internal] Gets a configuration by external id and user id, and if it doesn\'t exist creates it.
     * @param {ConfigurationApiInternalConfigurationsFromExternalIdPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigurationApi
     */
    internalConfigurationsFromExternalIdPost(requestParameters, options) {
        return ConfigurationApiFp(this.configuration).internalConfigurationsFromExternalIdPost(requestParameters.externalId, requestParameters.cartId, requestParameters.framePreviewId, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * ConfigurationPricesApi - axios parameter creator
 * @export
 */
export const ConfigurationPricesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Fetch the prices object for frame configurations
         * @param {string} configurationId
         * @param {string} [currency]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configurationsConfigurationIdPricesGet: (configurationId, currency, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'configurationId' is not null or undefined
            assertParamExists('configurationsConfigurationIdPricesGet', 'configurationId', configurationId);
            const localVarPath = `/configurations/{configurationId}/prices`
                .replace(`{${"configurationId"}}`, encodeURIComponent(String(configurationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (currency !== undefined) {
                localVarQueryParameter['currency'] = currency;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Fetch the price summary for the specified frame configuration
         * @param {string} configurationId
         * @param {string} [currency]
         * @param {string} [destinationCountryCode]
         * @param {string} [destinationStateCode]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configurationsConfigurationIdSummaryGet: (configurationId, currency, destinationCountryCode, destinationStateCode, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'configurationId' is not null or undefined
            assertParamExists('configurationsConfigurationIdSummaryGet', 'configurationId', configurationId);
            const localVarPath = `/configurations/{configurationId}/summary`
                .replace(`{${"configurationId"}}`, encodeURIComponent(String(configurationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (currency !== undefined) {
                localVarQueryParameter['currency'] = currency;
            }
            if (destinationCountryCode !== undefined) {
                localVarQueryParameter['destinationCountryCode'] = destinationCountryCode;
            }
            if (destinationStateCode !== undefined) {
                localVarQueryParameter['destinationStateCode'] = destinationStateCode;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * ConfigurationPricesApi - functional programming interface
 * @export
 */
export const ConfigurationPricesApiFp = function (configuration) {
    const localVarAxiosParamCreator = ConfigurationPricesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Fetch the prices object for frame configurations
         * @param {string} configurationId
         * @param {string} [currency]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configurationsConfigurationIdPricesGet(configurationId, currency, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.configurationsConfigurationIdPricesGet(configurationId, currency, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Fetch the price summary for the specified frame configuration
         * @param {string} configurationId
         * @param {string} [currency]
         * @param {string} [destinationCountryCode]
         * @param {string} [destinationStateCode]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configurationsConfigurationIdSummaryGet(configurationId, currency, destinationCountryCode, destinationStateCode, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.configurationsConfigurationIdSummaryGet(configurationId, currency, destinationCountryCode, destinationStateCode, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * ConfigurationPricesApi - factory interface
 * @export
 */
export const ConfigurationPricesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ConfigurationPricesApiFp(configuration);
    return {
        /**
         *
         * @summary Fetch the prices object for frame configurations
         * @param {ConfigurationPricesApiConfigurationsConfigurationIdPricesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configurationsConfigurationIdPricesGet(requestParameters, options) {
            return localVarFp.configurationsConfigurationIdPricesGet(requestParameters.configurationId, requestParameters.currency, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Fetch the price summary for the specified frame configuration
         * @param {ConfigurationPricesApiConfigurationsConfigurationIdSummaryGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configurationsConfigurationIdSummaryGet(requestParameters, options) {
            return localVarFp.configurationsConfigurationIdSummaryGet(requestParameters.configurationId, requestParameters.currency, requestParameters.destinationCountryCode, requestParameters.destinationStateCode, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ConfigurationPricesApi - object-oriented interface
 * @export
 * @class ConfigurationPricesApi
 * @extends {BaseAPI}
 */
export class ConfigurationPricesApi extends BaseAPI {
    /**
     *
     * @summary Fetch the prices object for frame configurations
     * @param {ConfigurationPricesApiConfigurationsConfigurationIdPricesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigurationPricesApi
     */
    configurationsConfigurationIdPricesGet(requestParameters, options) {
        return ConfigurationPricesApiFp(this.configuration).configurationsConfigurationIdPricesGet(requestParameters.configurationId, requestParameters.currency, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Fetch the price summary for the specified frame configuration
     * @param {ConfigurationPricesApiConfigurationsConfigurationIdSummaryGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigurationPricesApi
     */
    configurationsConfigurationIdSummaryGet(requestParameters, options) {
        return ConfigurationPricesApiFp(this.configuration).configurationsConfigurationIdSummaryGet(requestParameters.configurationId, requestParameters.currency, requestParameters.destinationCountryCode, requestParameters.destinationStateCode, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * ConfigurationTemplateApi - axios parameter creator
 * @export
 */
export const ConfigurationTemplateApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Get configuration templates for a partner id
         * @param {string} partnerId2
         * @param {string} [partnerId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configurationTemplatesPartnerIdGet: (partnerId2, partnerId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'partnerId2' is not null or undefined
            assertParamExists('configurationTemplatesPartnerIdGet', 'partnerId2', partnerId2);
            const localVarPath = `/configuration-templates/{partnerId}`
                .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId2)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (partnerId !== undefined) {
                localVarQueryParameter['partnerId'] = partnerId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary list configuration templates for a frameable product
         * @param {string} [frameableProductExternalId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        presetsGet: (frameableProductExternalId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/presets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (frameableProductExternalId !== undefined) {
                localVarQueryParameter['frameableProductExternalId'] = frameableProductExternalId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * ConfigurationTemplateApi - functional programming interface
 * @export
 */
export const ConfigurationTemplateApiFp = function (configuration) {
    const localVarAxiosParamCreator = ConfigurationTemplateApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Get configuration templates for a partner id
         * @param {string} partnerId2
         * @param {string} [partnerId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configurationTemplatesPartnerIdGet(partnerId2, partnerId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.configurationTemplatesPartnerIdGet(partnerId2, partnerId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary list configuration templates for a frameable product
         * @param {string} [frameableProductExternalId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        presetsGet(frameableProductExternalId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.presetsGet(frameableProductExternalId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * ConfigurationTemplateApi - factory interface
 * @export
 */
export const ConfigurationTemplateApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ConfigurationTemplateApiFp(configuration);
    return {
        /**
         *
         * @summary Get configuration templates for a partner id
         * @param {ConfigurationTemplateApiConfigurationTemplatesPartnerIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configurationTemplatesPartnerIdGet(requestParameters, options) {
            return localVarFp.configurationTemplatesPartnerIdGet(requestParameters.partnerId2, requestParameters.partnerId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary list configuration templates for a frameable product
         * @param {ConfigurationTemplateApiPresetsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        presetsGet(requestParameters = {}, options) {
            return localVarFp.presetsGet(requestParameters.frameableProductExternalId, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ConfigurationTemplateApi - object-oriented interface
 * @export
 * @class ConfigurationTemplateApi
 * @extends {BaseAPI}
 */
export class ConfigurationTemplateApi extends BaseAPI {
    /**
     *
     * @summary Get configuration templates for a partner id
     * @param {ConfigurationTemplateApiConfigurationTemplatesPartnerIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigurationTemplateApi
     */
    configurationTemplatesPartnerIdGet(requestParameters, options) {
        return ConfigurationTemplateApiFp(this.configuration).configurationTemplatesPartnerIdGet(requestParameters.partnerId2, requestParameters.partnerId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary list configuration templates for a frameable product
     * @param {ConfigurationTemplateApiPresetsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigurationTemplateApi
     */
    presetsGet(requestParameters = {}, options) {
        return ConfigurationTemplateApiFp(this.configuration).presetsGet(requestParameters.frameableProductExternalId, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * FeatureOptionApi - axios parameter creator
 * @export
 */
export const FeatureOptionApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Gets a feature option by id.
         * @param {string} featureOptionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featureOptionsFeatureOptionIdGet: (featureOptionId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'featureOptionId' is not null or undefined
            assertParamExists('featureOptionsFeatureOptionIdGet', 'featureOptionId', featureOptionId);
            const localVarPath = `/feature-options/{featureOptionId}`
                .replace(`{${"featureOptionId"}}`, encodeURIComponent(String(featureOptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Gets the feature option prices for a specific feature option.
         * @param {string} featureOptionId
         * @param {'Frame' | 'Glass' | 'Lighting' | 'Matchplate' | 'MatchplateExtras' | 'PassePartout' | 'Shipping' | 'Fold' | 'Sleeves' | 'ClubLogo' | 'Photos'} [featureType]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featureOptionsFeatureOptionIdPricesGet: (featureOptionId, featureType, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'featureOptionId' is not null or undefined
            assertParamExists('featureOptionsFeatureOptionIdPricesGet', 'featureOptionId', featureOptionId);
            const localVarPath = `/feature-options/{featureOptionId}/prices`
                .replace(`{${"featureOptionId"}}`, encodeURIComponent(String(featureOptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (featureType !== undefined) {
                localVarQueryParameter['featureType'] = featureType;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Gets all feature options of the specific feature type.
         * @param {string} [featureTypes]
         * @param {number} [offset]
         * @param {number} [pageSize]
         * @param {string} [sortColumn]
         * @param {string} [sortDirection]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featureOptionsGet: (featureTypes, offset, pageSize, sortColumn, sortDirection, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/feature-options`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (featureTypes !== undefined) {
                localVarQueryParameter['featureTypes'] = featureTypes;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }
            if (sortColumn !== undefined) {
                localVarQueryParameter['sortColumn'] = sortColumn;
            }
            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get all feature options
         * @param {string} [includingFeatureOptionIds] List of feature options that need to be included in the response
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featuresOptionsGet: (includingFeatureOptionIds, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/features/options`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (includingFeatureOptionIds !== undefined) {
                localVarQueryParameter['includingFeatureOptionIds'] = includingFeatureOptionIds;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * FeatureOptionApi - functional programming interface
 * @export
 */
export const FeatureOptionApiFp = function (configuration) {
    const localVarAxiosParamCreator = FeatureOptionApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Gets a feature option by id.
         * @param {string} featureOptionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featureOptionsFeatureOptionIdGet(featureOptionId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.featureOptionsFeatureOptionIdGet(featureOptionId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Gets the feature option prices for a specific feature option.
         * @param {string} featureOptionId
         * @param {'Frame' | 'Glass' | 'Lighting' | 'Matchplate' | 'MatchplateExtras' | 'PassePartout' | 'Shipping' | 'Fold' | 'Sleeves' | 'ClubLogo' | 'Photos'} [featureType]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featureOptionsFeatureOptionIdPricesGet(featureOptionId, featureType, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.featureOptionsFeatureOptionIdPricesGet(featureOptionId, featureType, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Gets all feature options of the specific feature type.
         * @param {string} [featureTypes]
         * @param {number} [offset]
         * @param {number} [pageSize]
         * @param {string} [sortColumn]
         * @param {string} [sortDirection]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featureOptionsGet(featureTypes, offset, pageSize, sortColumn, sortDirection, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.featureOptionsGet(featureTypes, offset, pageSize, sortColumn, sortDirection, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get all feature options
         * @param {string} [includingFeatureOptionIds] List of feature options that need to be included in the response
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featuresOptionsGet(includingFeatureOptionIds, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.featuresOptionsGet(includingFeatureOptionIds, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * FeatureOptionApi - factory interface
 * @export
 */
export const FeatureOptionApiFactory = function (configuration, basePath, axios) {
    const localVarFp = FeatureOptionApiFp(configuration);
    return {
        /**
         *
         * @summary Gets a feature option by id.
         * @param {FeatureOptionApiFeatureOptionsFeatureOptionIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featureOptionsFeatureOptionIdGet(requestParameters, options) {
            return localVarFp.featureOptionsFeatureOptionIdGet(requestParameters.featureOptionId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Gets the feature option prices for a specific feature option.
         * @param {FeatureOptionApiFeatureOptionsFeatureOptionIdPricesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featureOptionsFeatureOptionIdPricesGet(requestParameters, options) {
            return localVarFp.featureOptionsFeatureOptionIdPricesGet(requestParameters.featureOptionId, requestParameters.featureType, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Gets all feature options of the specific feature type.
         * @param {FeatureOptionApiFeatureOptionsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featureOptionsGet(requestParameters = {}, options) {
            return localVarFp.featureOptionsGet(requestParameters.featureTypes, requestParameters.offset, requestParameters.pageSize, requestParameters.sortColumn, requestParameters.sortDirection, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all feature options
         * @param {FeatureOptionApiFeaturesOptionsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featuresOptionsGet(requestParameters = {}, options) {
            return localVarFp.featuresOptionsGet(requestParameters.includingFeatureOptionIds, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * FeatureOptionApi - object-oriented interface
 * @export
 * @class FeatureOptionApi
 * @extends {BaseAPI}
 */
export class FeatureOptionApi extends BaseAPI {
    /**
     *
     * @summary Gets a feature option by id.
     * @param {FeatureOptionApiFeatureOptionsFeatureOptionIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeatureOptionApi
     */
    featureOptionsFeatureOptionIdGet(requestParameters, options) {
        return FeatureOptionApiFp(this.configuration).featureOptionsFeatureOptionIdGet(requestParameters.featureOptionId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Gets the feature option prices for a specific feature option.
     * @param {FeatureOptionApiFeatureOptionsFeatureOptionIdPricesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeatureOptionApi
     */
    featureOptionsFeatureOptionIdPricesGet(requestParameters, options) {
        return FeatureOptionApiFp(this.configuration).featureOptionsFeatureOptionIdPricesGet(requestParameters.featureOptionId, requestParameters.featureType, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Gets all feature options of the specific feature type.
     * @param {FeatureOptionApiFeatureOptionsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeatureOptionApi
     */
    featureOptionsGet(requestParameters = {}, options) {
        return FeatureOptionApiFp(this.configuration).featureOptionsGet(requestParameters.featureTypes, requestParameters.offset, requestParameters.pageSize, requestParameters.sortColumn, requestParameters.sortDirection, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get all feature options
     * @param {FeatureOptionApiFeaturesOptionsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeatureOptionApi
     */
    featuresOptionsGet(requestParameters = {}, options) {
        return FeatureOptionApiFp(this.configuration).featuresOptionsGet(requestParameters.includingFeatureOptionIds, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * FrameableProductApi - axios parameter creator
 * @export
 */
export const FrameableProductApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Get frameable product by external id.
         * @param {string} externalId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        frameableProductsExternalIdExternalGet: (externalId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'externalId' is not null or undefined
            assertParamExists('frameableProductsExternalIdExternalGet', 'externalId', externalId);
            const localVarPath = `/frameable-products/{externalId}/external`
                .replace(`{${"externalId"}}`, encodeURIComponent(String(externalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Update FrameConfiguration by Frameable ProductId.
         * @param {string} frameableProductId
         * @param {AdminConfigurationsConfigurationIdFrameConfigurationPatchRequest} [adminConfigurationsConfigurationIdFrameConfigurationPatchRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        frameableProductsFrameableProductIdFrameConfigurationPatch: (frameableProductId, adminConfigurationsConfigurationIdFrameConfigurationPatchRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'frameableProductId' is not null or undefined
            assertParamExists('frameableProductsFrameableProductIdFrameConfigurationPatch', 'frameableProductId', frameableProductId);
            const localVarPath = `/frameable-products/{frameableProductId}/frame-configuration`
                .replace(`{${"frameableProductId"}}`, encodeURIComponent(String(frameableProductId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(adminConfigurationsConfigurationIdFrameConfigurationPatchRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get frameable product by id.
         * @param {string} frameableProductId
         * @param {boolean} [includeDisabledPassePartouts]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        frameableProductsFrameableProductIdGet: (frameableProductId, includeDisabledPassePartouts, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'frameableProductId' is not null or undefined
            assertParamExists('frameableProductsFrameableProductIdGet', 'frameableProductId', frameableProductId);
            const localVarPath = `/frameable-products/{frameableProductId}`
                .replace(`{${"frameableProductId"}}`, encodeURIComponent(String(frameableProductId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (includeDisabledPassePartouts !== undefined) {
                localVarQueryParameter['includeDisabledPassePartouts'] = includeDisabledPassePartouts;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Update a frameable product.
         * @param {string} frameableProductId
         * @param {AdminFrameableProductsFrameableProductIdPutRequest} [adminFrameableProductsFrameableProductIdPutRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        frameableProductsFrameableProductIdPut: (frameableProductId, adminFrameableProductsFrameableProductIdPutRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'frameableProductId' is not null or undefined
            assertParamExists('frameableProductsFrameableProductIdPut', 'frameableProductId', frameableProductId);
            const localVarPath = `/frameable-products/{frameableProductId}`
                .replace(`{${"frameableProductId"}}`, encodeURIComponent(String(frameableProductId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(adminFrameableProductsFrameableProductIdPutRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get frameable products.
         * @param {number} [offset]
         * @param {number} [pageSize]
         * @param {string} [sortColumn]
         * @param {string} [sortDirection]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        frameableProductsGet: (offset, pageSize, sortColumn, sortDirection, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/frameable-products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }
            if (sortColumn !== undefined) {
                localVarQueryParameter['sortColumn'] = sortColumn;
            }
            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Create a new frameable product.
         * @param {AdminFrameableProductsFrameableProductIdPutRequest} [adminFrameableProductsFrameableProductIdPutRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        frameableProductsPost: (adminFrameableProductsFrameableProductIdPutRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/frameable-products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(adminFrameableProductsFrameableProductIdPutRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * FrameableProductApi - functional programming interface
 * @export
 */
export const FrameableProductApiFp = function (configuration) {
    const localVarAxiosParamCreator = FrameableProductApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Get frameable product by external id.
         * @param {string} externalId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        frameableProductsExternalIdExternalGet(externalId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.frameableProductsExternalIdExternalGet(externalId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Update FrameConfiguration by Frameable ProductId.
         * @param {string} frameableProductId
         * @param {AdminConfigurationsConfigurationIdFrameConfigurationPatchRequest} [adminConfigurationsConfigurationIdFrameConfigurationPatchRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        frameableProductsFrameableProductIdFrameConfigurationPatch(frameableProductId, adminConfigurationsConfigurationIdFrameConfigurationPatchRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.frameableProductsFrameableProductIdFrameConfigurationPatch(frameableProductId, adminConfigurationsConfigurationIdFrameConfigurationPatchRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get frameable product by id.
         * @param {string} frameableProductId
         * @param {boolean} [includeDisabledPassePartouts]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        frameableProductsFrameableProductIdGet(frameableProductId, includeDisabledPassePartouts, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.frameableProductsFrameableProductIdGet(frameableProductId, includeDisabledPassePartouts, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Update a frameable product.
         * @param {string} frameableProductId
         * @param {AdminFrameableProductsFrameableProductIdPutRequest} [adminFrameableProductsFrameableProductIdPutRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        frameableProductsFrameableProductIdPut(frameableProductId, adminFrameableProductsFrameableProductIdPutRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.frameableProductsFrameableProductIdPut(frameableProductId, adminFrameableProductsFrameableProductIdPutRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get frameable products.
         * @param {number} [offset]
         * @param {number} [pageSize]
         * @param {string} [sortColumn]
         * @param {string} [sortDirection]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        frameableProductsGet(offset, pageSize, sortColumn, sortDirection, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.frameableProductsGet(offset, pageSize, sortColumn, sortDirection, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Create a new frameable product.
         * @param {AdminFrameableProductsFrameableProductIdPutRequest} [adminFrameableProductsFrameableProductIdPutRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        frameableProductsPost(adminFrameableProductsFrameableProductIdPutRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.frameableProductsPost(adminFrameableProductsFrameableProductIdPutRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * FrameableProductApi - factory interface
 * @export
 */
export const FrameableProductApiFactory = function (configuration, basePath, axios) {
    const localVarFp = FrameableProductApiFp(configuration);
    return {
        /**
         *
         * @summary Get frameable product by external id.
         * @param {FrameableProductApiFrameableProductsExternalIdExternalGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        frameableProductsExternalIdExternalGet(requestParameters, options) {
            return localVarFp.frameableProductsExternalIdExternalGet(requestParameters.externalId, options).then((request) => request(axios, basePath));
        },
        /**
         * Update FrameConfiguration by Frameable ProductId.
         * @param {FrameableProductApiFrameableProductsFrameableProductIdFrameConfigurationPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        frameableProductsFrameableProductIdFrameConfigurationPatch(requestParameters, options) {
            return localVarFp.frameableProductsFrameableProductIdFrameConfigurationPatch(requestParameters.frameableProductId, requestParameters.adminConfigurationsConfigurationIdFrameConfigurationPatchRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get frameable product by id.
         * @param {FrameableProductApiFrameableProductsFrameableProductIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        frameableProductsFrameableProductIdGet(requestParameters, options) {
            return localVarFp.frameableProductsFrameableProductIdGet(requestParameters.frameableProductId, requestParameters.includeDisabledPassePartouts, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update a frameable product.
         * @param {FrameableProductApiFrameableProductsFrameableProductIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        frameableProductsFrameableProductIdPut(requestParameters, options) {
            return localVarFp.frameableProductsFrameableProductIdPut(requestParameters.frameableProductId, requestParameters.adminFrameableProductsFrameableProductIdPutRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get frameable products.
         * @param {FrameableProductApiFrameableProductsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        frameableProductsGet(requestParameters = {}, options) {
            return localVarFp.frameableProductsGet(requestParameters.offset, requestParameters.pageSize, requestParameters.sortColumn, requestParameters.sortDirection, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create a new frameable product.
         * @param {FrameableProductApiFrameableProductsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        frameableProductsPost(requestParameters = {}, options) {
            return localVarFp.frameableProductsPost(requestParameters.adminFrameableProductsFrameableProductIdPutRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * FrameableProductApi - object-oriented interface
 * @export
 * @class FrameableProductApi
 * @extends {BaseAPI}
 */
export class FrameableProductApi extends BaseAPI {
    /**
     *
     * @summary Get frameable product by external id.
     * @param {FrameableProductApiFrameableProductsExternalIdExternalGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FrameableProductApi
     */
    frameableProductsExternalIdExternalGet(requestParameters, options) {
        return FrameableProductApiFp(this.configuration).frameableProductsExternalIdExternalGet(requestParameters.externalId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Update FrameConfiguration by Frameable ProductId.
     * @param {FrameableProductApiFrameableProductsFrameableProductIdFrameConfigurationPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FrameableProductApi
     */
    frameableProductsFrameableProductIdFrameConfigurationPatch(requestParameters, options) {
        return FrameableProductApiFp(this.configuration).frameableProductsFrameableProductIdFrameConfigurationPatch(requestParameters.frameableProductId, requestParameters.adminConfigurationsConfigurationIdFrameConfigurationPatchRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get frameable product by id.
     * @param {FrameableProductApiFrameableProductsFrameableProductIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FrameableProductApi
     */
    frameableProductsFrameableProductIdGet(requestParameters, options) {
        return FrameableProductApiFp(this.configuration).frameableProductsFrameableProductIdGet(requestParameters.frameableProductId, requestParameters.includeDisabledPassePartouts, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update a frameable product.
     * @param {FrameableProductApiFrameableProductsFrameableProductIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FrameableProductApi
     */
    frameableProductsFrameableProductIdPut(requestParameters, options) {
        return FrameableProductApiFp(this.configuration).frameableProductsFrameableProductIdPut(requestParameters.frameableProductId, requestParameters.adminFrameableProductsFrameableProductIdPutRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get frameable products.
     * @param {FrameableProductApiFrameableProductsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FrameableProductApi
     */
    frameableProductsGet(requestParameters = {}, options) {
        return FrameableProductApiFp(this.configuration).frameableProductsGet(requestParameters.offset, requestParameters.pageSize, requestParameters.sortColumn, requestParameters.sortDirection, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create a new frameable product.
     * @param {FrameableProductApiFrameableProductsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FrameableProductApi
     */
    frameableProductsPost(requestParameters = {}, options) {
        return FrameableProductApiFp(this.configuration).frameableProductsPost(requestParameters.adminFrameableProductsFrameableProductIdPutRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * PartnersApi - axios parameter creator
 * @export
 */
export const PartnersApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Gets the partner by ID if it exists, creates the partner otherwise
         * @param {string} partnerId
         * @param {PartnersPartnerIdPostRequest} [partnersPartnerIdPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnersPartnerIdPost: (partnerId, partnersPartnerIdPostRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'partnerId' is not null or undefined
            assertParamExists('partnersPartnerIdPost', 'partnerId', partnerId);
            const localVarPath = `/partners/{partnerId}`
                .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(partnersPartnerIdPostRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * PartnersApi - functional programming interface
 * @export
 */
export const PartnersApiFp = function (configuration) {
    const localVarAxiosParamCreator = PartnersApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Gets the partner by ID if it exists, creates the partner otherwise
         * @param {string} partnerId
         * @param {PartnersPartnerIdPostRequest} [partnersPartnerIdPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnersPartnerIdPost(partnerId, partnersPartnerIdPostRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.partnersPartnerIdPost(partnerId, partnersPartnerIdPostRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * PartnersApi - factory interface
 * @export
 */
export const PartnersApiFactory = function (configuration, basePath, axios) {
    const localVarFp = PartnersApiFp(configuration);
    return {
        /**
         *
         * @summary Gets the partner by ID if it exists, creates the partner otherwise
         * @param {PartnersApiPartnersPartnerIdPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnersPartnerIdPost(requestParameters, options) {
            return localVarFp.partnersPartnerIdPost(requestParameters.partnerId, requestParameters.partnersPartnerIdPostRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * PartnersApi - object-oriented interface
 * @export
 * @class PartnersApi
 * @extends {BaseAPI}
 */
export class PartnersApi extends BaseAPI {
    /**
     *
     * @summary Gets the partner by ID if it exists, creates the partner otherwise
     * @param {PartnersApiPartnersPartnerIdPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnersApi
     */
    partnersPartnerIdPost(requestParameters, options) {
        return PartnersApiFp(this.configuration).partnersPartnerIdPost(requestParameters.partnerId, requestParameters.partnersPartnerIdPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
